import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ParcelCardView from '../components/ParcelCardView'
import myData from '../assets/static/properties.json'

import {
  MapProvider,
  Map,
  Source,
  Layer,
  Popup,
  Marker,
  NavigationControl,
} from 'react-map-gl/maplibre'

import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

import ParcelDetail from '../components/ParcelDetail'
import LayerControlGroup from '../components/LayerControlGroup'
import { useAuth } from '../hooks/getAuth'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import ExtendDrawBar from '../components/ExtendDrawBar'
import Spinner from '../components/Spinner'
import { mapboxGLDrawRectangleDrag } from '../components/MapboxGLDrawRectangleDrag'
import martinVectorTileLayers from '../hooks/martinVectorTileLayers'
import * as turf from '@turf/turf'
import { callAPI } from '../hooks/api'
import apnLayers from '../hooks/apnLayers'
import Collapsible from 'react-collapsible'

import { FaArrowAltCircleDown } from 'react-icons/fa'
import maplibregl from 'maplibre-gl'
import { toast } from 'react-toastify'
import MaplibreGeocoder from '@maplibre/maplibre-gl-geocoder'
import '@maplibre/maplibre-gl-geocoder/dist/maplibre-gl-geocoder.css'
import 'react-dropdown/style.css'
import legendImage from '../assets/svg/new legend.webp'

import SampleGeoJson from '../data/sample.json'

import '../index.css'
import '../assets/css/styles.css'
import ApnSearchModal from '../components/ApnSearchModal'
import { getBboxFromGeoJson, undefinedToZero } from '../hooks/utils'
import ranchApnLayers from '../hooks/ranchApnLayers'
import RanchSelectModal from '../components/RanchSelectModal'
import allRanchParcels from '../hooks/allRanchParcels'
import { isMobile, browserName, CustomView } from 'react-device-detect'
import MobileParcelDetail from '../components/MobileParcelDetail'
import BrowserCheck from '../components/BrowserCheck'

import { useSearchParams } from 'react-router-dom'
import ParcelCount from '../components/ParcelCount'
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride'
import CustomNavigationControl from '../components/CustomNavigationControl'
import InfoPopup from '../components/InfoPopup'
import QueryFilterModal from '../components/QueryFilterModal'
import { FaCircleInfo } from 'react-icons/fa6'
import initialApnLayers from '../hooks/initialApnLayers'
import InitialParcelCardView from '../components/InitialParcelCardView'
import RanchSelector from '../components/RanchSelector'

import TutorialGeoJson from '../data/tutorial.json'

import { EFreeTrialStatusType } from '@/components/welcome-modal/welcome-modal'

export default function Tutorial({
  lnProperties,
  setLnProperties,
  loopnetOriginalData,
  setLoopnetOriginalData,
  freshRestart,
  mapBounds,
  setMapBounds,
  currentTab,
  setCurrentTab,
  localAuth,
  joyrideRun,
  setJoyrideRun,
}) {
  const removeStylesheet = (href) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')

  const mapRef = useRef(null)

  const [parcels, setParcels] = useState([])
  const [ranchParcels, setRanchParcels] = useState([])

  const [apnSource, setApnSource] = useState({})
  const [apnLayer, setApnLayer] = useState({})
  const [apnOutlineLayer, setApnOutlineLayer] = useState({})
  const [apnLabelLayer, setApnLabelLayer] = useState({})

  const [ranchApnSource, setRanchApnSource] = useState({})
  const [ranchApnLayer, setRanchApnLayer] = useState({})
  const [ranchApnOutlineLayer, setRanchApnOutlineLayer] = useState({})
  const [ranchApnLabelLayer, setRanchApnLabelLayer] = useState({})

  const [ranches, setRanches] = useState([])
  const [selectedRanch, setSelectedRanch] = useState({})

  const isDemoUser =
    localAuth.sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'

  useEffect(() => {
    const handleBackButton = () => {
      if (isDemoUser) {
        localStorage.setItem('auth', JSON.stringify({}))
        setAuth(null)
        setIsLoggedIn(false)
        setShowModal(false)
        deleteGeoJson()
        setApnLayer({})
        setApnOutlineLayer({})
        setApnLabelLayer({})
        setApnSource({})
        setRanchApnLayer({})
        setRanchApnOutlineLayer({})
        setRanchApnLabelLayer({})
        setRanchApnSource({})
        setMapBounds([[], []])
        setAoiVisibility({
          apn: false,
          sagbi: false,
          mls: false,
        })
        setShowParcelPopup(false)
        setShowPopup(false)
        setShowClickPopup(false)
        clearRanchSelection()
      }
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [isDemoUser])

  const { auth, setAuth, isLoggedIn, setIsLoggedIn } = useAuth()

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [mapLoaded, setMapLoaded] = useState(false)
  const [currentZoomLevel, setCurrentZoomLevel] = useState(13)
  const [selectedProperty, setSelectedProperty] = useState({})
  const [mapWidthStyle, setMapWidthStyle] = useState(mapWidthStyleFunc())
  const [propertyWidthStyle, setPropertyWidthStyle] = useState(
    propertyWidthStyleFunc()
  )
  const [ranchesGeojson, setRanchesGeojson] = useState(null)

  const [initialRanch, setInitialRanch] = useState(0)

  const [initialParcelLayersData, setInitialParcelLayersData] = useState({})
  const [initialApnSource, setInitialApnSource] = useState({})
  const [initialApnLayer, setInitialApnLayer] = useState({})
  const [initialApnOutlineLayer, setInitialApnOutlineLayer] = useState({})

  const [initialMarker, setInitialMarker] = useState(false)
  const [initialMarkerLat, setInitialMarkerLat] = useState(null)
  const [initialMarkerLon, setInitialMarkerLon] = useState(null)

  const [ranchParcelsSource, setRanchParcelsSource] = useState({})
  const [ranchParcelsLayer, setRanchParcelsLayer] = useState({})
  const [ranchParcelsOutlineLayer, setRanchParcelsOutlineLayer] = useState({})

  const clearRanchSelection = () => {
    setSelectedRanch({})
    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})
    setMapBounds([[], []])
  }

  const [selectedParcelIds, setSelectedParcelIds] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showRanchSelectModal, setShowRanchSelectModal] = useState(false)
  const [clickedGeojson, setClickedGeojson] = useState(null)

  const [tutorialInitialGeojson, setTutorialInitialGeojson] = useState(
    TutorialGeoJson.initialParcels
  )
  const [tutorialQueriedGeojson, setTutorialQueriedGeojson] = useState(
    TutorialGeoJson.queriedParcels
  )

  const [popupContent, setPopupContent] = useState(null)
  const [searchParams, setSearchParams] = useSearchParams()

  const [initialParcels, setInitialParcels] = useState([])

  const [currentIndex, setCurrentIndex] = useState(-1)

  // State to manage modal visibility
  const [isQueryFilterModalOpen, setIsQueryFilterModalOpen] = useState(false)
  const [filterGeoJson, setFilterGeoJson] = useState({})

  //Free-trial
  const trialStatus = localAuth?.trial_status
  const isTrialModal =
    trialStatus &&
    [
      EFreeTrialStatusType.NEW_TRIAL,
      EFreeTrialStatusType.START_TRIAL,
      EFreeTrialStatusType.ACTIVE_TRIAL,
    ].includes(trialStatus)

  useEffect(() => {
    const joyrideStep = isTrialModal ? 1 : 0
    if (isTrialModal && joyrideStep === 1) setCurrentStep(joyrideStep)
  }, [isTrialModal])

  // Function to open the modal
  const openModal = () => {
    setIsQueryFilterModalOpen(true)
  }

  // Function to close the modal
  const closeModal = () => {
    setIsQueryFilterModalOpen(false)
  }

  var handleClose = () => setShowModal(false)
  var handleSuccess = () => {}

  const filterApnSourceById = (idToRemove) => {
    const updatedFeatures = apnSource.data.features.filter(
      (feature) => feature.id !== idToRemove
    )
    setApnSource((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        features: updatedFeatures,
      },
    }))
  }

  async function onParcelDeleteFromDetail(parcelId) {
    const updateParcels = parcels.filter((parcel) => parcel.id !== parcelId)
    setMapBounds([[], []])
    setShowParcelPopup(false)
    setParcels(updateParcels)
    filterApnSourceById(parcelId)
  }

  function onRanchParcelDelete(parcelId, ranchId, parcelRefId) {
    console.log('onRanchParcelDelete', parcelId, ranchId, parcelRefId)
  }

  function getRanches(ranch_id = 0) {
    var tutorial_ranch = [
      { ranch_id: -1, ranch_name: 'Tutorial Ranch 1', mod_tie: 1723750738431 },
      { ranch_id: -1, ranch_name: 'Tutorial Ranch 2', mod_tie: 1723750738431 },
      { ranch_id: -1, ranch_name: 'Tutorial Ranch 3', mod_tie: 1723750738431 },
      { ranch_id: -1, ranch_name: 'Tutorial Ranch 4', mod_tie: 1723750738431 },
    ]
    setRanches(tutorial_ranch)
  }

  function getRanchesGeojson() {
    var endpoint = '/get_ranches_geojson'
    var params = {
      session_key: localAuth.sessionKey,
    }
    setRanchesGeojson(null)
    callAPI(endpoint, params).then((res) => {
      if (res.status === 'fail') {
        toast.warn(res.msg)
        setLoading(false)
        return
      } else if (res.status === 'expire') {
        toast.warn(res.msg)
        setLoading(false)
        logout()
        return
      }
      setRanchesGeojson(res.ranches_geojson)
    })
  }

  function onEdit(parcelId) {
    setShowRanchSelectModal(true)
    setSelectedParcelIds([parcelId])
  }

  function onEditAll(p = []) {
    if (p.length == 0) p = parcels

    const allParcelIds = p.map((parcel) => parcel.id)
    if (allParcelIds.length === 0) return
    setShowRanchSelectModal(true)
    setSelectedParcelIds(allParcelIds)
  }

  function addInitialParcelToRanch(ranch, all = false) {}

  function addParcelToRanch(ranch) {}

  const onLoaded = (map) => {
    map.resize()
  }

  function logout() {
    // TODO : signOut
    localStorage.setItem('auth', JSON.stringify({}))
    setAuth(null)
    setIsLoggedIn(false)
    setShowModal(false)
    deleteGeoJson()
    setApnLayer({})
    setApnOutlineLayer({})
    setApnLabelLayer({})
    setApnSource({})
    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})
    setMapBounds([[], []])
    setAoiVisibility({
      apn: false,
      sagbi: false,
      mls: false,
    })
    setAoiVisible(false)
    setShowParcelPopup(false)
    setShowPopup(false)
    setShowClickPopup(false)
    clearRanchSelection()
    navigate(
      '/' +
        (searchParams.get('locations')
          ? '?locations=' + searchParams.get('locations')
          : '')
    )
  }
  function mapWidthStyleFunc() {
    return { width: '100vw', height: '100vh' }
    if (window.innerWidth < 690) {
      return { width: '100vw', height: 'calc(100vh - 70px)' }
    } else if (window.innerWidth < 768) {
      return { width: '65vw', height: 'calc(100vh - 70px)' }
    } else if (window.innerWidth < 1024) {
      return { width: '70vw', height: 'calc(100vh - 70px)' }
    } else if (window.innerWidth < 1280) {
      return { width: '75vw', height: 'calc(100vh - 70px)' }
    } else {
      return { width: '75vw', height: 'calc(100vh - 70px)' }
    }
  }

  function propertyWidthStyleFunc() {
    if (window.innerWidth < 690) {
      return {
        minHeight: '10px',
        maxHeight: '70vh',
        width: '100vw',
        height: '160px',
      }
    } else if (window.innerWidth < 768) {
      return {
        minWidth: '35vw',
        width: '35vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else if (window.innerWidth < 1024) {
      return {
        minWidth: '30vw',
        width: '30vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else if (window.innerWidth < 1280) {
      return {
        minWidth: '25vw',
        width: '25vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    } else {
      return {
        minWidth: '25vw',
        width: '25vw',
        height: 'calc(100vh - 70px)',
        bottom: '0px',
      }
    }
  }

  function onPropertyClicked(property) {
    setShowModal(true)
    setSelectedProperty(property)
  }

  function handleInitialParcelOut() {
    if (Object.keys(initialApnSource).length) {
      const updatedFeatures = initialApnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedInitialApnSource = {
        ...initialApnSource,
        data: {
          ...initialApnSource.data,
          features: updatedFeatures,
        },
      }
      setInitialApnSource(updatedInitialApnSource)
    }
  }
  function handleInitialParcelSelection(parcel) {
    handleInitialParcelOut()

    if (initialApnSource) {
      const updatedFeatures = initialApnSource.data.features.map((feature) => {
        if (
          feature.properties.parcel_id == parcel.feature.properties.parcel_id
        ) {
          setInitialMarker(true)
          setInitialMarkerLat(parcel.feature.properties.latitude)
          setInitialMarkerLon(parcel.feature.properties.longitude)

          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#79ff00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })

      const updatedInitialApnSource = {
        ...initialApnSource,
        data: {
          ...initialApnSource.data,
          features: updatedFeatures,
        },
      }

      setInitialApnSource(updatedInitialApnSource)

      // Extract map bounds and parcel bounds
      const mapBounds = mapRef.current.getBounds()
      const [mapSw, mapNe] = [
        mapBounds.getSouthWest(),
        mapBounds.getNorthEast(),
      ]
      const [parcelMinLng, parcelMinLat, parcelMaxLng, parcelMaxLat] =
        parcel.feature.bbox

      // Check if parcelBounds are within mapBounds
      const isWithinBounds =
        parcelMinLat >= mapSw.lat &&
        parcelMaxLat <= mapNe.lat &&
        parcelMinLng >= mapSw.lng &&
        parcelMaxLng <= mapNe.lng
      // Helper function to get bounding box
      const getBoundingBox = (coordinates) => {
        const minLat = Math.min(...coordinates.map((coord) => coord[1]))
        const maxLat = Math.max(...coordinates.map((coord) => coord[1]))
        const minLon = Math.min(...coordinates.map((coord) => coord[0]))
        const maxLon = Math.max(...coordinates.map((coord) => coord[0]))

        return [
          [minLon, minLat],
          [maxLon, maxLat],
        ]
      }
      if (!isWithinBounds) {
        // Create new bounds that include both mapBounds and parcelBounds
        const newBounds = getBoundingBox([
          [parcelMinLng, parcelMinLat],
          [parcelMaxLng, parcelMaxLat],
          [mapSw.lng, mapSw.lat],
          [mapNe.lng, mapNe.lat],
        ])

        // Update map bounds
        mapRef.current.fitBounds(newBounds, { padding: 50 })
      }
    }
  }

  function handlePropertyMouseOut(parcel) {
    if (Object.keys(apnSource).length) {
      const updatedFeatures = apnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedApnSource = {
        ...apnSource,
        data: {
          ...apnSource.data,
          features: updatedFeatures,
        },
      }
      setApnSource(updatedApnSource)
    }
    if (loopnetOriginalData.length) {
      const updatedData = loopnetOriginalData.map((item) => ({
        ...item,
        color: 'red',
      }))
      setLoopnetOriginalData(updatedData)
    }
    if (Object.keys(ranchApnSource).length) {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        const { selected, ...updatedProperties } = feature.properties
        return {
          ...feature,
          properties: updatedProperties,
        }
      })

      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }
      setRanchApnSource(updatedRanchApnSource)
    }
  }

  function handlePropertyMouseOver(parcel) {
    handlePropertyMouseOut()
    if (apnSource && parcel.type === 'aoi') {
      const updatedFeatures = apnSource.data.features.map((feature) => {
        if (feature.id == parcel.id) {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#FFFF00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })
      const updatedApnSource = {
        ...apnSource,
        data: {
          ...apnSource.data,
          features: updatedFeatures,
        },
      }

      setApnSource(updatedApnSource)
    }
    if (ranchApnSource && parcel.type === 'ranch') {
      const updatedFeatures = ranchApnSource.data.features.map((feature) => {
        if (feature.id == parcel.id) {
          return {
            ...feature,
            properties: {
              ...feature.properties,
              selected: '#FFFF00',
            },
          }
        } else {
          const { selected, ...updatedProperties } = feature.properties
          return {
            ...feature,
            properties: updatedProperties,
          }
        }
      })
      const updatedRanchApnSource = {
        ...ranchApnSource,
        data: {
          ...ranchApnSource.data,
          features: updatedFeatures,
        },
      }

      setRanchApnSource(updatedRanchApnSource)
    }
    if (loopnetOriginalData && parcel.type === 'ln') {
      const updatedData = loopnetOriginalData.map((item) =>
        item.id == parcel.id ? { ...item, color: 'yellow' } : item
      )
      setLoopnetOriginalData(updatedData)
    }
  }

  function handleResize() {
    setMapWidthStyle(mapWidthStyleFunc())
    setPropertyWidthStyle(propertyWidthStyleFunc())
  }

  useEffect(() => {
    if (isDemoUser) {
      freshRestart()
      setAoiVisibility({
        apn: false,
        sagbi: false,
        mls: false,
      })
      setAoiVisible(false)
      setShowParcelPopup(false)
      setShowPopup(false)
      setShowClickPopup(false)
    }
    if (!joyrideRun) {
      navigate(
        '/' +
          (searchParams.get('locations')
            ? '?locations=' + searchParams.get('locations')
            : '')
      )
    }
    setCurrentTab('home')
    getRanches()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  function undefinedToEmpty(str) {
    if (typeof str === 'undefined') {
      return ''
    } else {
      if (str === 'white_area') return 'White Area'
      else if (str === 'rated') return 'Rated'
      else if (str === 'unrated') return 'Unrated'
      return str
    }
  }

  const [baseMapSourceStyles, setBaseMapSourceStyles] = useState({})
  const [baseMapLayerStyles, setBaseMapLayerStyles] = useState({})
  const [layerList, setLayerList] = useState([])
  const [configList, setConfigList] = useState([])

  const [aoiVisible, setAoiVisible] = useState(false)
  const popupRef = useRef(null)
  const searchRef = useRef(null)

  const MODES = MapboxDraw.modes

  MODES.draw_rectangle = mapboxGLDrawRectangleDrag
  const draw = new MapboxDraw({
    displayControlsDefault: false,
    modes: MODES,
  })

  const BASE_URL =
    document.location.protocol + '//' + document.location.hostname + ':4011'
  const Geo = {
    // required
    forwardGeocode: async (config) => {
      try {
        const query = config.query
        const response = await fetch(
          BASE_URL + `/autocomplete?input=${encodeURIComponent(query)}`
        )

        if (!response.ok) {
          throw new Error(
            `Failed to fetch suggestions, status ${response.status}`
          )
        }

        const data = await response.json()

        // Ensure predictions array exists and is not empty
        if (data.length === 0) {
          throw new Error('No predictions found')
        }
        return { features: [data[0]] } // Return suggestions array wrapped in an object
      } catch (error) {
        console.error('Error in getSuggestions:', error)
        throw error // Rethrow the error to propagate it further
      }
    },

    // optional
    reverseGeocode: async (config) => {
      const { lat, lon } = config.query
      const limit = config.limit || 5
      const response = await fetch(
        BASE_URL + `/reverse_geocode?lat=${lat}&lon=${lon}`
      )
      const data = await response.json()

      const features = data.results.slice(0, limit).map((result) => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [
              result.geometry.location.lng,
              result.geometry.location.lat,
            ],
          },
          properties: {
            name: result.formatted_address,
            place_id: result.place_id,
          },
        }
      })

      return { features: features }
    },
    // optional
    getSuggestions: async (config) => {
      try {
        const query = config.query
        const response = await fetch(
          BASE_URL + `/autocomplete?input=${encodeURIComponent(query)}`
        )

        if (!response.ok) {
          throw new Error(
            `Failed to fetch suggestions, status ${response.status}`
          )
        }

        const data = await response.json()

        return { features: data }
      } catch (error) {
        console.error('Error in getSuggestions:', error)
        throw error // Rethrow the error to propagate it further
      }
    },

    // optional
    searchByPlaceId: async (config) => {
      const placeId = config.query.place_id
      const response = await fetch(
        BASE_URL + `/place_details?place_id=${placeId}`
      )
      const data = await response.json()

      const result = data.result
      const feature = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            result.geometry.location.lng,
            result.geometry.location.lat,
          ],
        },
        properties: {
          name: result.formatted_address,
          place_id: result.place_id,
        },
      }

      return { features: [feature] }
    },
  }

  const options = {
    marker: true,
    popup: true,
    showResultsWhileTyping: true,
    minLength: 4,
    flyTo: {
      padding: 15, // If you want some minimum space around your result
      easing: function (t) {
        return t
      },
      maxZoom: 15,
    },
  }
  const geocoder = new MaplibreGeocoder(Geo, {
    maplibregl: maplibregl,
    ...options,
  })

  const [isSearchOn, setIsSearchOn] = useState({
    rect: false,
    apn: false,
  })

  const [isLayerOn, setIsLayerOn] = useState(false)

  const drawRectangle = () => {
    // setShowParcelPopup(false)
    // if (draw.getMode() === "draw_rectangle")
    //     draw?.changeMode("simple_select");
    // else
    //     draw?.changeMode("draw_rectangle");
    // setIsSearchOn((prevState) => ({
    //     ["rect"]: draw.getMode() === "draw_rectangle",
    // }))
  }
  const apnSearch = () => {
    // setShowParcelPopup(false)
    // setIsSearchOn((prevState) => ({
    //     ...prevState,
    //     ["apn"]: true,
    // }))
  }
  const toggleLayers = () => {
    setIsLayerOn((prevState) => !prevState)
    const layersCloseElement = document.querySelector('.layers-close-icon')
    const layersElement = document.querySelector('.layers-icon')

    if (layersElement) {
      layersElement.className = 'layers-close-icon toggle-layers'
      layersElement.title = 'Hide Layers'
    }
    if (layersCloseElement) {
      layersCloseElement.className = 'layers-icon toggle-layers'
      layersCloseElement.title = 'Show Layers'
    }
  }
  function addRectSearchEvent(e) {
    // if(isSearchOn.rect){
    //     setIsSearchOn((prevState) => ({
    //         ...prevState,
    //         ["rect"]: !isSearchOn.rect,
    //     }))
    //     mapRef.current.off('mouseup', addRectSearchEvent)
    // }
  }

  function removeInitialParcels(parcelIds) {
    const map = mapRef.current
    const sources = map.getStyle().sources
    const prevSource = sources['initial_APN_source']
    const geojson = prevSource.data
    setInitialParcels((prevParcels) => {
      // Return a new array excluding the parcel with the matching parcelId
      return prevParcels.filter(
        (parcel) => !parcelIds.includes(parcel.feature.properties.parcel_id)
      )
    })
    // Filter the features array
    const filteredFeatures = geojson.features.filter((feature) => {
      return !parcelIds.includes(feature.properties.parcel_id)
    })

    // Create a new GeoJSON object with the filtered features
    const updatedPrevGeojson = {
      ...prevSource.data, // Keep all the existing properties of prevSource.data
      features: filteredFeatures, // Replace the features array with the filtered one
    }
    var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
      initialApnLayers(updatedPrevGeojson)

    setInitialApnSource(initialApnSource)
    setInitialApnLayer(initialApnLayer)
    setInitialApnOutlineLayer(initialApnOutlineLayer)
    setInitialMarker(false)
    setShowInitialRightClickPopup(false)
  }
  let clickTimeout
  let isDoubleClick = false

  const setInitialParcelLayersDataByPoint = async (map, point) => {
    const sources = map.getStyle().sources
    const layerName = {
      sgma_county: 'County',
      hydra_gsa: 'GSA',
      hydra_wd_vw: 'Water Districts',
      provisional_crops_2023: 'Statewide Crops',
    }
    const currentLayers = Object.keys(sources)
      .filter((key) => layerName.hasOwnProperty(key)) // Check if key exists in json
      .map((key) => layerName[key]) // Get the corresponding value

    if (currentLayers.length > 0) {
      const features = map.queryRenderedFeatures(point, {
        layers: currentLayers, // Specify the vector layer to query
      })
      var layersData = {}
      features.map((feature) => {
        if (feature.source === 'sgma_county')
          layersData['County Name'] = feature.properties.namelsad
        else if (feature.source === 'hydra_gsa') {
          if (layersData['GSA'])
            layersData['GSA'] =
              layersData['GSA'] + ', ' + feature.properties.gsa_name
          else layersData['GSA'] = feature.properties.gsa_name
        } else if (feature.source === 'hydra_wd_vw') {
          if (layersData['Water District'])
            layersData['Water District'] =
              layersData['Water District'] +
              ', ' +
              feature.properties.agencyname
          else layersData['Water District'] = feature.properties.agencyname
        }
        // } else if(feature.source === "provisional_crops_2023") layersData["Main Crop"] = feature.properties.main_crop
      })
      setInitialParcelLayersData(layersData)
    } else {
      setInitialParcelLayersData({})
    }
  }

  useEffect(() => {
    if (Object.keys(tutorialInitialGeojson).length) {
      const parcelId = tutorialInitialGeojson.features[0].properties.parcel_id
      const latitude = tutorialInitialGeojson.features[0].properties.latitude
      const longitude = tutorialInitialGeojson.features[0].properties.longitude
      // Add the Parcel ID and the list items
      setPopupLat(latitude)
      setPopupLon(longitude)

      var aoi_parcels = []
      // Process the new parcels
      tutorialInitialGeojson.features.map(async (feature, index) => {
        var imgUrls = []
        aoi_parcels.push({
          type: 'aoi',
          id: feature.id,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            address:
              'address' in feature.properties
                ? feature.properties['address']
                : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'PARCEL_APN' in feature.properties
                ? feature.properties['PARCEL_APN']
                : 'parcel_id' in feature.properties
                  ? feature.properties['parcel_id']
                  : 'N/A',
            // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      // Update the state with the new parcels
      setInitialParcels(aoi_parcels)

      var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
        initialApnLayers(tutorialInitialGeojson)

      setInitialApnSource(initialApnSource)
      setInitialApnLayer(initialApnLayer)
      setInitialApnOutlineLayer(initialApnOutlineLayer)
      setClickedGeojson({
        type: 'FatureCollection',
        features: tutorialInitialGeojson.features,
      })
      setRightClickParcelId(
        tutorialInitialGeojson.features[0].properties.parcel_id
      )
      setInitialMarker(true)
      setInitialMarkerLat(latitude)
      setInitialMarkerLon(longitude)
    }
  }, [tutorialInitialGeojson])

  useEffect(() => {
    if (Object.keys(tutorialQueriedGeojson).length) {
      var aoi_parcels = []

      // Process the new parcels
      tutorialQueriedGeojson.features.map(async (feature, index) => {
        var imgUrls = []
        if ('sv' in feature.properties) {
          // Create a data URL for the image
          imgUrls.push(`data:image/png;base64,${feature.properties['sv']}`)
        }
        feature.id = index
        const hydraScore =
          'hs' in feature.properties
            ? feature.properties['hs'] === 'not yet rated'
              ? 'NR'
              : feature.properties['hs']
            : 'NR'
        const ss =
          'ss' in feature.properties
            ? feature.properties['ss'] === null
              ? 'NR'
              : feature.properties['ss']
            : 'NR'
        aoi_parcels.push({
          type: 'aoi',
          id: index,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            timestamp: false,
            address:
              'address' in feature.properties
                ? feature.properties['address']
                : 'N/A',
            hydraScore: hydraScore,
            ss: ss,
            regularPrice:
              'price' in feature.properties
                ? feature.properties['price']
                : 'mkt_val_bldg' in feature.properties ||
                    'mkt_val_land' in feature.properties
                  ? '$' +
                    (
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_bldg)
                      ) +
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_land)
                      )
                    ).toString()
                  : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'PARCEL_APN' in feature.properties
                ? feature.properties['PARCEL_APN']
                : 'parcel_id' in feature.properties
                  ? feature.properties['parcel_id']
                  : 'N/A',
            gsa:
              'gsa' in feature.properties
                ? [feature.properties['gsa']]
                : ['N/A'],
            wd:
              'wd' in feature.properties ? [feature.properties['wd']] : ['N/A'],
            acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      if (aoi_parcels.length > 0) {
        setVisibility({
          ...visibility,
          ['queried_parcels']: true,
        })
      }

      setParcels(aoi_parcels.reverse())

      var { apnSource, apnLayer, apnOutlineLayer, apnLabelLayer } = apnLayers(
        mapRef.current,
        tutorialQueriedGeojson
      )

      setApnSource(apnSource)
      setApnLayer(apnLayer)
      setApnOutlineLayer(apnOutlineLayer)
      setApnLabelLayer(apnLabelLayer)
    }
  }, [tutorialQueriedGeojson])

  async function defaultClickEvent(e) {
    const overlayExists = document.querySelector('.react-joyride__overlay')

    if (overlayExists) {
      return
    }

    const ctrlKeyPressed = e.originalEvent.ctrlKey
    const coordinates = e.lngLat
    const map = mapRef.current

    const sources = map.getStyle().sources
    const layerName = {
      sgma_ewrims: 'Water Rights (eWRIMS)',
    }
    const currentLayers = Object.keys(sources)
      .filter((key) => layerName.hasOwnProperty(key)) // Check if key exists in json
      .map((key) => layerName[key]) // Get the corresponding value
    const features = map.queryRenderedFeatures(e.point, {
      layers: currentLayers, // Specify the vector layer to query
    })
    if (
      features.filter((feature) => feature.source === 'sgma_ewrims').length > 0
    )
      return

    setInitialParcelLayersDataByPoint(map, e.point)

    const apnSource = sources['APN_source']
    const ranchApnSource = sources['Ranch_APN_source']
    const prevSource = sources['initial_APN_source']
    const filterSource = sources['filter-source']

    if (showInitialRightClickPopup) {
      setShowInitialRightClickPopup(false)
      return
    }

    // Do nothing if clicked on queried parcel
    if (apnSource || ranchApnSource) {
      // Get features from both sources
      const apnFeatures = apnSource ? apnSource.data.features : []
      const ranchApnFeatures = ranchApnSource
        ? ranchApnSource.data.features
        : []

      const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

      // Check if clicked point is within any feature in apnSource
      const clickedApnFeatures = apnFeatures.filter((feature) =>
        turf.booleanPointInPolygon(clickedPoint, feature)
      )

      // Check if clicked point is within any feature in ranchApnSource
      const clickedRanchApnFeatures = ranchApnFeatures.filter((feature) =>
        turf.booleanPointInPolygon(clickedPoint, feature)
      )

      // If clicked point is in apnSource and NOT in ranchApnSource
      if (clickedApnFeatures.length > 0 || clickedRanchApnFeatures.length > 0) {
        if (
          e.type === 'click' ||
          e.type === 'touchend' ||
          e.type === 'dblclick'
        ) {
          return // Do nothing
        } else if (e.type === 'contextmenu' && clickedApnFeatures.length > 0) {
          // Show context menu popup
          setShowRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedApnFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setInitialMarker(false)
          return
        } else if (
          e.type === 'contextmenu' &&
          clickedRanchApnFeatures.length > 0
        ) {
          // Show context menu popup
          setShowRanchRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedRanchApnFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRightClickPopup(false)
          setInitialMarker(false)
          return
        }
      }
    }

    // Remove clicked parcel
    if (prevSource) {
      if (e.type === 'click' || e.type === 'touchend') {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          const button = document.querySelector(
            'button[data-test-id="button-primary"][aria-label="Next"]'
          )
          if (button) {
            const span = button.querySelector('span') // Find the span inside the button
            if (span && span.textContent.trim().includes('Next (3/')) {
              // Check if the text matches
              return
            }
          }
          const parcelId = clickedFeatures[0].properties.parcel_id
          removeInitialParcels([parcelId])
          return
        }
      } else if (e.type === 'contextmenu') {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          const parcelId = clickedFeatures[0].properties.parcel_id
          // Add the Parcel ID and the list items
          setShowInitialRightClickPopup(true)
          setShowRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)

          var aoi_parcels = []
          // Process the new parcels
          geojson.features.map(async (feature, index) => {
            var imgUrls = []
            if (feature.properties['parcel_id'] === parcelId) {
              // Update the feature's latitude and longitude in geojson.features
              geojson.features[index].properties.latitude =
                e.lngLat.lat.toFixed(5)
              geojson.features[index].properties.longitude =
                e.lngLat.lng.toFixed(5)
            }
            aoi_parcels.push({
              type: 'aoi',
              id: feature.id,
              data: {
                name:
                  'owner' in feature.properties
                    ? feature.properties['owner']
                    : 'Area of Interest',
                imgUrls: imgUrls,
                address:
                  'address' in feature.properties
                    ? feature.properties['address']
                    : 'N/A',
                county:
                  'county_name' in feature.properties
                    ? feature.properties['county_name']
                    : null,
                apn:
                  'PARCEL_APN' in feature.properties
                    ? feature.properties['PARCEL_APN']
                    : 'parcel_id' in feature.properties
                      ? feature.properties['parcel_id']
                      : 'N/A',
                // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
                geolocation: {
                  lat: feature.properties['latitude'],
                  lng: feature.properties['longitude'],
                },
              },
              feature: feature,
            })
          })

          // Update the state with the new parcels
          setInitialParcels(aoi_parcels)

          var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
            initialApnLayers(geojson)

          setInitialApnSource(initialApnSource)
          setInitialApnLayer(initialApnLayer)
          setInitialApnOutlineLayer(initialApnOutlineLayer)
          setClickedGeojson({
            type: 'FatureCollection',
            features: clickedFeatures,
          })
          setRightClickParcelId(clickedFeatures[0].properties.parcel_id)
          setInitialMarker(true)
          setInitialMarkerLat(coordinates.lat)
          setInitialMarkerLon(coordinates.lng)
          return
        }
      }
    }
    if (filterSource) {
      if (e.type === 'click' || e.type === 'touchend') {
        const geojson = filterSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          e.preventDefault()
          setInitialMarker(false)
          setShowRightClickPopup(false)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          var aoi_parcels = []

          let mergedGeojson = {
            type: 'FeatureCollection',
            features: clickedFeatures,
            bbox: clickedFeatures[0].bbox,
          }

          if (ctrlKeyPressed && prevSource) {
            mergedGeojson = {
              ...prevSource.data,
              features: [...prevSource.data.features, ...clickedFeatures],
            }
          }
          // Process the new parcels
          mergedGeojson.features.map(async (feature, index) => {
            var imgUrls = []
            // if ('sv' in feature.properties) {
            //     const base64Image = btoa(feature.properties['sv']);
            //     imgUrls.push(`data:image/png;base64,${base64Image}`);
            // }
            aoi_parcels.push({
              type: 'aoi',
              id: feature.id,
              data: {
                name:
                  'owner' in feature.properties
                    ? feature.properties['owner']
                    : 'Area of Interest',
                imgUrls: imgUrls,
                address:
                  'address' in feature.properties
                    ? feature.properties['address']
                    : 'N/A',
                county:
                  'county_name' in feature.properties
                    ? feature.properties['county_name']
                    : null,
                apn:
                  'PARCEL_APN' in feature.properties
                    ? feature.properties['PARCEL_APN']
                    : 'parcel_id' in feature.properties
                      ? feature.properties['parcel_id']
                      : 'N/A',
                // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
                geolocation: {
                  lat: e.lngLat.lat.toFixed(5),
                  lng: e.lngLat.lng.toFixed(5),
                },
              },
              feature: feature,
            })
          })

          // Update the state with the new parcels
          setInitialParcels(aoi_parcels)

          var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
            initialApnLayers(mergedGeojson)

          setInitialApnSource(initialApnSource)
          setInitialApnLayer(initialApnLayer)
          setInitialApnOutlineLayer(initialApnOutlineLayer)
          setClickedGeojson({
            type: 'FeatureCollection',
            features: clickedFeatures,
            bbox: clickedFeatures[0].bbox,
          })

          return
        }
      } else if (e.type === 'contextmenu') {
        const geojson = filterSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          // Show context menu popup
          setShowFilterRightClickPopup(true)
          setPopupLat(e.lngLat.lat)
          setPopupLon(e.lngLat.lng)
          setRightClickParcelId(clickedFeatures[0].properties.parcel_id)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          setShowRightClickPopup(false)
          setInitialMarker(false)
          return
        }
      }
    }

    // Handle double-click event
    if (e.type === 'dblclick') {
      clearTimeout(clickTimeout) // Cancel any pending single-click
      isDoubleClick = true // Mark that a double-click happened
      if (prevSource) {
        const geojson = prevSource.data
        const clickedPoint = [e.lngLat.lng, e.lngLat.lat]

        const clickedFeatures = geojson.features.filter((feature) =>
          turf.booleanPointInPolygon(clickedPoint, feature)
        )
        if (clickedFeatures.length > 0) {
          e.preventDefault()
          // setInitialMarker(false)
          setShowRightClickPopup(false)
          setShowInitialRightClickPopup(false)
          setShowRanchRightClickPopup(false)
          toast.warn(
            "Please try on your account by clicking 'Map' tab. This will exit the tutorial."
          )
          // queryApn('', '', '', '', '', JSON.stringify(clickedFeatures), true)
          return
        }
      }
      e.preventDefault()
      // setInitialMarker(false)
      setShowRightClickPopup(false)
      setShowInitialRightClickPopup(false)
      setShowRanchRightClickPopup(false)
      toast.warn(
        "Please try on your account by clicking 'Map' tab. This will exit the tutorial."
      )
      // queryApn('', '', e.lngLat.lat, e.lngLat.lng, '', '', ctrlKeyPressed)

      return
    }

    // Delay for single-click detection
    if (e.type === 'click' || e.type === 'touchend') {
      isDoubleClick = false // Reset the double-click flag
      clickTimeout = setTimeout(async () => {
        if (!isDoubleClick) {
          setInitialMarker(true)
          setInitialMarkerLat(coordinates.lat)
          setInitialMarkerLon(coordinates.lng)
          initialQueryApn(
            '',
            '',
            coordinates.lat,
            coordinates.lng,
            ctrlKeyPressed,
            e.type === 'contextmenu'
          )
          return
        }
      }, 200) // Set the delay to 300ms (adjustable)
    }
  }

  useEffect(() => {
    if (clickedGeojson) {
      initialParcels.map(async (parcel, index) => {
        if (
          mapRef.current &&
          parcel.data.apn === clickedGeojson.features[0].properties.parcel_id
        ) {
          const pointInView = await mapRef.current.project({
            lng: parcel.feature.properties.longitude,
            lat: parcel.feature.properties.latitude,
          })
          setInitialParcelLayersDataByPoint(mapRef.current, pointInView)
          setCurrentIndex(index)
          handleInitialParcelSelection(parcel)
        }
      })
    }
  }, [clickedGeojson])
  useEffect(() => {
    if (mapRef.current) {
      if (!isMobile) {
        if (isSearchOn.rect) {
          mapRef.current.getCanvas().style.cursor = 'crosshair'
          mapRef.current.on('mouseup', addRectSearchEvent)
        } else {
          mapRef.current.getCanvas().style.cursor = 'pointer'
        }
      }
    }
  }, [isSearchOn])

  useEffect(() => {
    if (
      mapRef.current &&
      Object.keys(apnSource).length > 0 &&
      Object.keys(apnLayer).length > 0 &&
      Object.keys(apnOutlineLayer).length > 0 &&
      Object.keys(apnLabelLayer).length > 0
    ) {
      setAoiVisibility({ ...aoiVisibility, ['apn']: true, ['mls']: true })
      setAoiVisible(true)
      mapRef.current.on('click', apnLayer.id, function (e) {
        parcels.forEach((parcel) => {
          if (parcel.id == e.features[0].id) {
            setPopupProperty(parcel)
          }
        })

        var coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
      mapRef.current.on('touchend', apnLayer.id, function (e) {
        parcels.forEach((parcel) => {
          if (parcel.id == e.features[0].id) {
            setPopupProperty(parcel)
          }
        })

        var coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
    }
  }, [mapRef.current, apnLayer, apnOutlineLayer, apnLabelLayer])

  useEffect(() => {
    if (
      mapRef.current &&
      Object.keys(ranchApnSource).length > 0 &&
      Object.keys(ranchApnLayer).length > 0 &&
      Object.keys(ranchApnOutlineLayer).length > 0 &&
      Object.keys(ranchApnLabelLayer).length > 0
    ) {
      setAoiVisibility({ ...aoiVisibility, ['apn']: true, ['mls']: true })
      setAoiVisible(true)
      mapRef.current.on('click', ranchApnLayer.id, function (e) {
        ranchParcels.forEach((ranchParcel) => {
          if (ranchParcel.id == e.features[0].id) {
            setPopupProperty(ranchParcel)
          }
        })

        var coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
      mapRef.current.on('touchend', ranchApnLayer.id, function (e) {
        ranchParcels.forEach((ranchParcel) => {
          if (ranchParcel.id == e.features[0].id) {
            setPopupProperty(ranchParcel)
          }
        })

        var coordinates = e.lngLat
        setPopupLat(coordinates.lat)
        setPopupLon(coordinates.lng)
        setIsLoopnetProperty(false)
        setShowParcelPopup(true)
      })
    }
  }, [mapRef.current, ranchApnLayer, ranchApnOutlineLayer, ranchApnLabelLayer])

  useEffect(() => {
    if (!joyrideRun) {
      if (mapRef.current && searchParams.get('locations')) {
        const locations = JSON.parse(atob(searchParams.get('locations')))
        setSearchPopup(true)
        mapRef.current.flyTo({
          center: [locations[0]['lon'], locations[0]['lat']],
          zoom: 14,
          essential: true,
        })
      } else if (mapRef.current && mapBounds[0].length === 0) {
        navigator.geolocation.getCurrentPosition((position) => {
          mapRef.current.flyTo({
            center: [position.coords.longitude, position.coords.latitude],
            zoom: 14,
            essential: true,
          })
        })
      }
    }
  }, [joyrideRun, mapRef.current])

  useEffect(() => {
    if (!mapRef.current) {
      return
    }

    const getCurrentSources = async () => {
      const map = mapRef.current
      if (map) {
        const sources = map.getStyle().sources
        const prevSource = sources['initial_APN_source']
        if (prevSource) {
          const selectedFeature = prevSource.data.features.find(
            (feature) => feature.properties.selected
          )
          if (selectedFeature) {
            const pointInView = await map.project({
              lng: selectedFeature.properties.longitude,
              lat: selectedFeature.properties.latitude,
            })
            setInitialParcelLayersDataByPoint(map, pointInView)
          }
        }
      }
    }

    // Set up the event listener for when sources are updated
    mapRef.current.on('sourcedata', (e) => {
      if (e.isSourceLoaded) {
        const layerNames = [
          'sgma_county',
          'hydra_gsa',
          'hydra_wd_vw',
          'provisional_crops_2023',
        ]
        if (layerNames.includes(e.sourceId)) getCurrentSources()
      }
    })

    // Clean up the listener when the component unmounts
    return () => {
      if (mapRef.current) {
        mapRef.current.off('sourcedata', getCurrentSources)
      }
    }
  }, [mapRef.current])

  async function onDraw(e) {
    // var endpoint = '/get_query_parcel_counts'
    // var params = {"bounds" : turf.bbox(e.features[0].geometry)}
    // callAPI(endpoint, params)
    // .then(async (res)=>{
    //     const proceed = await confirm({confirmation : `You have selected ${res} parcels. Do you want to proceed?`})
    //     if(proceed)
    //         await queryApn("","","","",e.features[0].geometry)
    //     else
    //         deleteGeoJson()
    // })
  }

  async function initialQueryApn(
    county = '',
    apn = '',
    lat = 0,
    lon = 0,
    append = false,
    rightclick = false
  ) {
    var params = {}

    var endpoint = '/initial_query_parcel'
    if (county !== '' && apn !== '') {
      params = { county: county, apns: apn, session_key: localAuth.sessionKey }
    } else if (lat !== 0 && lon !== 0) {
      params = { lat: lat, lon: lon, session_key: localAuth.sessionKey }
    }

    deleteGeoJson()

    if (isLoggedIn) {
      setLoading(true)
      var res = await callAPI(endpoint, params)

      if (res.status === 'fail') {
        setInitialMarker(false)
        toast.warn(res.msg)
        deleteGeoJson()
        setLoading(false)
        return
      } else if (res.status === 'expire') {
        setInitialMarker(false)
        toast.warn(res.msg)
        deleteGeoJson()
        setLoading(false)
        logout()
        return
      }

      // Create an array to store the new parcels
      var aoi_parcels = []
      res.geojson.features[0].properties.latitude = lat.toFixed(5)
      res.geojson.features[0].properties.longitude = lon.toFixed(5)

      // Merge the new GeoJSON with the existing one if append is true
      let mergedGeojson = res.geojson
      const sources = mapRef.current.getStyle().sources
      const prevSource = sources['initial_APN_source']

      if (append && prevSource) {
        mergedGeojson = {
          ...prevSource.data,
          features: [...prevSource.data.features, ...res.geojson.features],
        }
      }
      // Process the new parcels
      mergedGeojson.features.map(async (feature, index) => {
        var imgUrls = []
        // if ('sv' in feature.properties) {
        //     const base64Image = btoa(feature.properties['sv']);
        //     imgUrls.push(`data:image/png;base64,${base64Image}`);
        // }
        aoi_parcels.push({
          type: 'aoi',
          id: feature.id,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            address:
              'address' in feature.properties
                ? feature.properties['address']
                : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'parcel_id' in feature.properties
                ? feature.properties['parcel_id']
                : 'N/A',
            // "geolocation": { lat: feature.properties["latitude"], lng: feature.properties["longitude"] }
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      // Update the state with the new parcels
      setInitialParcels(aoi_parcels)

      var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
        initialApnLayers(mergedGeojson)

      setInitialApnSource(initialApnSource)
      setInitialApnLayer(initialApnLayer)
      setInitialApnOutlineLayer(initialApnOutlineLayer)
      setClickedGeojson(res.geojson)

      if (rightclick) {
        let unionFeatures = null
        mergedGeojson.features.forEach((feature) => {
          if (unionFeatures) {
            // Union with the previous geometry
            unionFeatures = turf.union(unionFeatures, feature)
          } else {
            // Initialize the union geometry with the first feature
            unionFeatures = feature
          }
        })
        setShowInitialRightClickPopup(true)
        setPopupLat(lat)
        setPopupLon(lon)
      }

      setLoading(false)
      const button = document.querySelector(
        'button[data-test-id="button-primary"][aria-label="Next"]'
      )
      if (button) {
        const span = button.querySelector('span') // Find the span inside the button
        if (span && span.textContent.trim().includes('Next (2/')) {
          // Check if the text matches
          button.click() // Trigger the click if the text matches
        }
      }
    }
  }

  async function queryApn(
    county = '',
    apn = '',
    lat = '',
    lon = '',
    geom = '',
    geojsonStr = '',
    append = false
  ) {
    var params = {}
    var endpoint = '/initial_query_parcel'
    if (county !== '' && apn !== '') {
      params = { county: county, apns: apn, session_key: localAuth.sessionKey }
    } else if (lat !== '' && lon !== '') {
      params = { lat: lat, lon: lon, session_key: localAuth.sessionKey }
    } else if (geom !== '') {
      return
    }
    deleteGeoJson()

    if (isLoggedIn) {
      setLoading(true)

      const prevSource = mapRef.current.getStyle().sources['initial_APN_source']

      let mergedGeojson = { type: 'FeatureCollection', features: [] }
      if (geojsonStr === '') {
        var res = await callAPI(endpoint, params)
        const newParcelIds = res.geojson.features.map(
          (feature) => feature.properties.parcel_id
        )
        if (prevSource) {
          // Filter the features array
          const filteredFeatures = prevSource.data.features.filter(
            (prevFeature) => {
              return !newParcelIds.includes(prevFeature.properties.parcel_id)
            }
          )

          // Create a new GeoJSON object with the filtered features
          const updatedPrevGeojson = {
            ...prevSource.data, // Keep all the existing properties of prevSource.data
            features: filteredFeatures, // Replace the features array with the filtered one
          }
          var { initialApnSource, initialApnLayer, initialApnOutlineLayer } =
            initialApnLayers(updatedPrevGeojson)

          setInitialApnSource(initialApnSource)
          setInitialApnLayer(initialApnLayer)
          setInitialApnOutlineLayer(initialApnOutlineLayer)
          setShowInitialRightClickPopup(false)
          setInitialParcels((prevParcels) => {
            // Return a new array excluding the parcel with the matching parcelId
            return prevParcels.filter(
              (parcel) =>
                !newParcelIds.includes(parcel.feature.properties.parcel_id)
            )
          })
          mergedGeojson = res.geojson
        }
      } else {
        var passedGeoJson = JSON.parse(geojsonStr)
        mergedGeojson = {
          type: 'FeatureCollection',
          features: passedGeoJson,
          bbox: passedGeoJson[0].bbox,
        }
      }

      mergedGeojson.features.forEach((feature) => {
        feature.properties.hs = '100' // Add hs property
        feature.properties.ss = 100 // Add ss property
        feature.properties.acreage_calc = 0 // Add acreage_calc property
        feature.properties.sv =
          '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' // Add sv property
      })

      var aoi_parcels = []

      const sources = mapRef.current.getStyle().sources
      const prevApnSource = sources['APN_source']
      if (append && prevApnSource) {
        mergedGeojson = {
          ...prevApnSource.data,
          features: [...prevApnSource.data.features, ...mergedGeojson.features],
        }
      } else {
        setParcels(aoi_parcels)
      }
      // Process the new parcels
      mergedGeojson.features.map(async (feature, index) => {
        var imgUrls = []
        if ('sv' in feature.properties) {
          // Create a data URL for the image
          imgUrls.push(`data:image/png;base64,${feature.properties['sv']}`)
        }
        feature.id = index
        const hydraScore =
          'hs' in feature.properties
            ? feature.properties['hs'] === 'not yet rated'
              ? 'NR'
              : feature.properties['hs']
            : 'NR'
        const ss =
          'ss' in feature.properties
            ? feature.properties['ss'] === null
              ? 'NR'
              : feature.properties['ss']
            : 'NR'
        aoi_parcels.push({
          type: 'aoi',
          id: index,
          data: {
            name:
              'owner' in feature.properties
                ? feature.properties['owner']
                : 'Area of Interest',
            imgUrls: imgUrls,
            timestamp: false,
            address:
              'address' in feature.properties
                ? feature.properties['address']
                : 'N/A',
            hydraScore: hydraScore,
            ss: ss,
            regularPrice:
              'price' in feature.properties
                ? feature.properties['price']
                : 'mkt_val_bldg' in feature.properties ||
                    'mkt_val_land' in feature.properties
                  ? '$' +
                    (
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_bldg)
                      ) +
                      parseFloat(
                        undefinedToZero(feature.properties.mkt_val_land)
                      )
                    ).toString()
                  : 'N/A',
            county:
              'county_name' in feature.properties
                ? feature.properties['county_name']
                : null,
            apn:
              'PARCEL_APN' in feature.properties
                ? feature.properties['PARCEL_APN']
                : 'parcel_id' in feature.properties
                  ? feature.properties['parcel_id']
                  : 'N/A',
            gsa:
              'gsa' in feature.properties
                ? [feature.properties['gsa']]
                : ['N/A'],
            wd:
              'wd' in feature.properties ? [feature.properties['wd']] : ['N/A'],
            acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
            geolocation: {
              lat: feature.properties['latitude'],
              lng: feature.properties['longitude'],
            },
          },
          feature: feature,
        })
      })

      if (aoi_parcels.length > 0) {
        setVisibility({
          ...visibility,
          ['queried_parcels']: true,
        })
      }

      setParcels(aoi_parcels.reverse())

      var { apnSource, apnLayer, apnOutlineLayer, apnLabelLayer } = apnLayers(
        mapRef.current,
        mergedGeojson
      )

      setApnSource(apnSource)
      setApnLayer(apnLayer)
      setApnOutlineLayer(apnOutlineLayer)
      setApnLabelLayer(apnLabelLayer)

      var bbox = res.geojson.bbox

      const getBoundingBox = (coordinates) => {
        const minLat = Math.min(...coordinates.map((coord) => coord[0]))
        const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
        const minLon = Math.min(...coordinates.map((coord) => coord[1]))
        const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

        return [
          [minLon, minLat],
          [maxLon, maxLat],
        ]
      }

      setMapBounds(
        getBoundingBox([
          [bbox[1], bbox[0]],
          [bbox[3], bbox[2]],
        ])
      )
      setLoading(false)

      return aoi_parcels.reverse()
    }
    return []
  }

  useEffect(() => {
    if (parcels.length > 0 && currentStep === 2) {
      const button = document.querySelector(
        'button[data-test-id="button-primary"][aria-label="Next"]'
      )
      if (button) {
        button.click()
      }
    }
  }, [parcels])

  async function drawParcelsByRanchId() {
    setRanchApnLayer({})
    setRanchApnOutlineLayer({})
    setRanchApnLabelLayer({})
    setRanchApnSource({})

    var aoi_parcels = []
    setRanchParcels(aoi_parcels)
    TutorialGeoJson.ranchParcels.features.map(async (feature) => {
      feature['id'] = `100${feature.id}`
      var imgUrls = [feature.properties.sv]
      const hydraScore =
        'hs' in feature.properties
          ? feature.properties['hs'] === 'not yet rated'
            ? 'NR'
            : feature.properties['hs']
          : 'NR'
      const ss =
        'ss' in feature.properties
          ? feature.properties['ss'] === null
            ? 'NR'
            : feature.properties['ss']
          : 'NR'
      aoi_parcels.push({
        type: 'ranch',
        id: feature.id,
        data: {
          name:
            'owner' in feature.properties
              ? feature.properties['owner']
              : 'Area of Interest',
          imgUrls: imgUrls,
          timestamp: feature.properties.mod_time,
          address:
            'address' in feature.properties
              ? feature.properties['address']
              : 'N/A',
          hydraScore: hydraScore,
          ss: ss,
          regularPrice:
            'price' in feature.properties
              ? feature.properties['price']
              : 'mkt_val_bldg' in feature.properties
                ? '$' +
                  (
                    parseFloat(feature.properties.mkt_val_bldg) +
                    parseFloat(feature.properties.mkt_val_land)
                  ).toString()
                : 'N/A',
          county:
            'county_name' in feature.properties
              ? feature.properties['county_name']
              : null,
          apn:
            'PARCEL_APN' in feature.properties
              ? feature.properties['PARCEL_APN']
              : 'parcel_id' in feature.properties
                ? feature.properties['parcel_id']
                : 'N/A',
          gsa:
            'gsa' in feature.properties ? [feature.properties['gsa']] : ['N/A'],
          wd: 'wd' in feature.properties ? [feature.properties['wd']] : ['N/A'],
          acre: parseFloat(feature.properties['acreage_calc']).toFixed(2),
          geolocation: {
            lat: feature.properties['latitude'],
            lng: feature.properties['longitude'],
          },
        },
        feature: feature,
      })
    })
    // Sort parcels by APN in ascending order
    aoi_parcels.sort((a, b) => {
      let apnA = a.data.apn || '' // Default to empty string if undefined
      let apnB = b.data.apn || ''
      return apnA.localeCompare(apnB)
    })
    setRanchParcels(aoi_parcels)

    var {
      ranchApnSource,
      ranchApnLayer,
      ranchApnOutlineLayer,
      ranchApnLabelLayer,
    } = ranchApnLayers(mapRef.current, TutorialGeoJson.ranchParcels)

    setRanchApnSource(ranchApnSource)
    setRanchApnLayer(ranchApnLayer)
    setRanchApnOutlineLayer(ranchApnOutlineLayer)
    setRanchApnLabelLayer(ranchApnLabelLayer)
    var bbox = getBboxFromGeoJson(TutorialGeoJson.ranchParcels)

    const getBoundingBox = (coordinates) => {
      const minLat = Math.min(...coordinates.map((coord) => coord[0]))
      const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
      const minLon = Math.min(...coordinates.map((coord) => coord[1]))
      const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

      return [
        [minLon, minLat],
        [maxLon, maxLat],
      ]
    }

    setMapBounds(
      getBoundingBox([
        [bbox[1], bbox[0]],
        [bbox[3], bbox[2]],
      ])
    )
    setLoading(false)
  }

  useEffect(() => {
    if (ranchesGeojson) {
      setRanchParcelsSource({})
      setRanchParcelsLayer({})
      setRanchParcelsOutlineLayer({})
      var { ranchParcelsSource, ranchParcelsLayer, ranchParcelsOutlineLayer } =
        allRanchParcels(mapRef.current, ranchesGeojson)
      setRanchParcelsSource(ranchParcelsSource)
      setRanchParcelsLayer(ranchParcelsLayer)
      setRanchParcelsOutlineLayer(ranchParcelsOutlineLayer)
    }
  }, [ranchesGeojson])

  useEffect(() => {
    const filterDeleteElement = document.getElementById(
      'mapboxgl-delete-filter-button'
    )
    if (filterDeleteElement) {
      // Ensure filterGeoJson has a valid structure
      const hasFeatures = filterGeoJson?.features?.length > 0
      filterDeleteElement.style.visibility = hasFeatures ? 'visible' : 'hidden'
    }
  }, [filterGeoJson])

  const deleteGeoJson = () => {
    // var mapLayers = mapRef.current.getStyle().layers
    try {
      draw.deleteAll()
    } catch (e) {}
  }

  class QueryFilterButton {
    onAdd(map) {
      this._map = map

      // Create container for both buttons
      this._container = document.createElement('div')
      this._container.className = 'my-custom-controls' // Use flex container for layout

      // Filter Criteria button
      const filterButton = document.createElement('button')
      filterButton.className =
        'mapboxgl-ctrl-icon mapboxgl-ctrl-query-button cursor-pointer' // Keep this class only on the button
      filterButton.textContent = 'Filter Criteria'
      filterButton.type = 'button'
      filterButton.onclick = () => {
        openModal()
      }
      this._container.appendChild(filterButton)

      // Delete button
      const deleteButton = document.createElement('button')
      deleteButton.className =
        'mapboxgl-ctrl-icon mapboxgl-delete-filter-button cursor-pointer bg-white z-[200]'
      deleteButton.id = 'mapboxgl-delete-filter-button'
      deleteButton.style = 'visibility: hidden'

      deleteButton.type = 'button'
      deleteButton.title = 'Clear all filtered parcels'
      // deleteButton.textContent = 'Hlloe'
      deleteButton.onclick = () => {
        // setVisibility({
        //     ...visibility,
        //     ['filtered_parcels']: false
        // });
        // setFilterGeoJson({})
      }

      // SVG path for MdOutlineDeleteSweep icon
      const deleteIcon = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      )
      deleteIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      deleteIcon.setAttribute('viewBox', '0 0 24 24')
      deleteIcon.setAttribute('fill', 'black')
      deleteIcon.setAttribute('width', '24')
      deleteIcon.setAttribute('height', '24')
      deleteIcon.innerHTML = `
                <path d="M6.00514 9.97515C6.5252 9.97515 6.9468 9.55355 6.9468 9.03349C6.9468 8.51342 6.5252 8.09183 6.00514 8.09183C5.48507 8.09183 5.06348 8.51342 5.06348 9.03349C5.06348 9.55355 5.48507 9.97515 6.00514 9.97515Z" fill="black"/><path d="M3.44166 12.8697C3.96173 12.8697 4.38332 12.4481 4.38332 11.928C4.38332 11.408 3.96173 10.9864 3.44166 10.9864C2.9216 10.9864 2.5 11.408 2.5 11.928C2.5 12.4481 2.9216 12.8697 3.44166 12.8697Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7278 2.85713C18.6619 2.30506 17.3503 2.72156 16.7983 3.78741L14.387 8.44265C14.3741 8.46761 14.3629 8.49302 14.3535 8.51873C13.1724 8.47823 12.0024 8.99998 11.2133 9.92347C10.2836 11.0115 9.13984 12.1989 8.16244 12.8052C6.76894 13.6697 5.61694 13.9812 4.90156 14.0918C4.48315 14.1565 4.14355 14.4259 3.97812 14.7752C3.80532 15.1401 3.81835 15.6182 4.15414 15.9882C4.88416 16.7927 6.3074 18.1103 8.91789 19.7706C10.726 20.9205 12.3471 21.5565 13.2195 21.8512C13.8881 22.077 14.6027 21.8188 14.9863 21.2442C15.4714 20.5177 16.3232 19.1478 17.0546 17.4808C17.5957 16.2476 18.0619 14.9766 18.508 13.7077C18.8843 12.6373 18.715 11.5083 18.1429 10.6158L20.6558 5.79099C21.2111 4.72469 20.7953 3.41008 19.7278 2.85713ZM17.1952 9.62116L19.5028 5.19048C19.726 4.76198 19.5589 4.23368 19.1299 4.01147C18.7015 3.78961 18.1745 3.95699 17.9526 4.38532L15.662 8.80765C15.7387 8.84019 15.8148 8.87556 15.8902 8.9138L16.7272 9.33818C16.8921 9.42176 17.0483 9.51653 17.1952 9.62116ZM17.2816 13.2765C17.189 13.54 17.0913 13.8139 16.9901 14.093L11.7147 11.3246C11.8846 11.1352 12.0475 10.9484 12.2017 10.768C12.9869 9.84904 14.2756 9.55273 15.3023 10.0733L16.1393 10.4977C17.1706 11.0205 17.6582 12.2054 17.2816 13.2765ZM8.84774 13.9099C9.48917 13.512 10.1585 12.9305 10.7866 12.3055L10.795 12.31L16.5321 15.3208C16.3114 15.8946 16.0846 16.456 15.8642 16.9585C15.1735 18.5326 14.365 19.8336 13.9052 20.5223C13.8396 20.6204 13.7332 20.6526 13.6355 20.6196C13.2518 20.49 12.7036 20.2861 12.0502 19.9904C12.3535 19.6706 12.7934 19.1478 13.215 18.4296C13.3972 18.1192 13.2919 17.7252 12.9798 17.5495C12.6678 17.3739 12.2671 17.4831 12.085 17.7935C11.7461 18.3708 11.3322 18.9395 10.8247 19.383C10.4376 19.1741 10.0319 18.9385 9.61554 18.6736C9.277 18.4583 8.95996 18.2495 8.66318 18.0477C8.8176 17.9438 8.98693 17.8165 9.16871 17.6606C9.44209 17.4261 9.46924 17.0208 9.22935 16.7553C8.98946 16.4899 8.57337 16.4647 8.29999 16.6992C7.89764 17.0442 7.61662 17.1755 7.50335 17.2198C6.4683 16.4421 5.77483 15.8036 5.32603 15.338C6.19552 15.1763 7.42378 14.7933 8.84774 13.9099Z" fill="black"/>
            `
      deleteButton.appendChild(deleteIcon)
      this._container.appendChild(deleteButton)

      return this._container
    }

    onRemove() {
      this._container.parentNode.removeChild(this._container)
      this._map = undefined
    }
  }

  // class QueryFilterButton {
  //     onAdd(map) {
  //         this._map = map;
  //         this._container = document.createElement('button');
  //         this._container.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-query-button cursor-pointer';
  //         this._container.textContent = 'Filter Criteria';
  //         this._container.type = 'button';
  //         this._container.onclick = () => {
  //             openModal()
  //         };
  //         return this._container;
  //     }

  //     onRemove() {
  //         this._container.parentNode.removeChild(this._container);
  //         this._map = undefined;
  //     }
  // }
  const onMapLoad = () => {
    if (mapRef.current) {
      mapRef.current.on('draw.create', onDraw)
      const drawBar = new ExtendDrawBar({
        draw: draw,
        buttons: isMobile
          ? [
              {
                on: 'click',
                action: apnSearch,
                classes: ['search-apn-icon'],
                title: 'Search by APN',
              },
              {
                on: 'click',
                action: toggleLayers,
                classes: ['layers-icon', 'toggle-layers'],
                title: 'Show Layers',
              },
            ]
          : [
              {
                on: 'click',
                action: drawRectangle,
                classes: ['aoi-icon'],
                title: 'Select by area',
              },
              {
                on: 'click',
                action: apnSearch,
                classes: ['search-apn-icon'],
                title: 'Search by APN',
              },
              {
                on: 'click',
                action: toggleLayers,
                classes: ['layers-icon', 'toggle-layers'],
                title: 'Show Layers',
              },
            ],
      })

      mapRef.current.addControl(geocoder, 'top-left')
      // Add the Query by Filter button
      const queryFilterButton = new QueryFilterButton()
      mapRef.current.addControl(queryFilterButton, 'top-left') // Right after geocoder

      mapRef.current.addControl(drawBar, 'top-left')

      mapRef.current.getCanvas().style.cursor = 'default'
      mapRef.current.on('click', defaultClickEvent)
      mapRef.current.on('contextmenu', defaultClickEvent)
      mapRef.current.on('dblclick', defaultClickEvent)

      // Variables to track touch position and movement
      let touchStartX = 0
      let touchStartY = 0
      let isTouchMove = false
      const moveThreshold = 10 // Define a small threshold for touch movement

      // Handle touchstart event
      function handleTouchStart(event) {
        const touch = event.point // Get the first touch point
        touchStartX = touch.x
        touchStartY = touch.y
        isTouchMove = false // Reset the touchmove flag
      }

      // Handle touchmove event
      function handleTouchMove(event) {
        const touch = event.point // Get the first touch point
        const moveX = Math.abs(touch.x - touchStartX)
        const moveY = Math.abs(touch.y - touchStartY)

        // If the movement is greater than the threshold, consider it as a touchmove gesture
        if (moveX > moveThreshold || moveY > moveThreshold) {
          isTouchMove = true
        }
      }

      // Handle touchend event
      function handleTouchEnd(event) {
        // Only trigger the click event if the touchmove did not happen
        if (!isTouchMove) {
          defaultClickEvent(event)
        }
      }
      // Add touch event listeners to the mapRef element
      mapRef.current.on('touchstart', handleTouchStart)
      mapRef.current.on('touchend', handleTouchEnd)
      mapRef.current.on('touchmove', handleTouchMove)

      const navigationControl = new CustomNavigationControl({
        showCompass: true,
        showZoom: true,
      })
      mapRef.current.addControl(navigationControl, 'top-left')

      const mapInstance = mapRef.current.getMap()
      mapInstance.on('zoom', function (e) {
        setCurrentZoomLevel(mapInstance.getZoom())
      })

      mapRef.current.setGlyphs(
        'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf'
      )
      var { layerList, configList } = martinVectorTileLayers(
        mapRef.current,
        localAuth
      )
      setLayerList(layerList)
      setConfigList(configList)
      fitToMapBounds()
      setMapLoaded(true)
    }
  }

  const [showPopup, setShowPopup] = useState(false)
  const [showClickPopup, setShowClickPopup] = useState(false)
  let activeLayerId = ''
  const [searchPopup, setSearchPopup] = useState(true)
  const [showParcelPopup, setShowParcelPopup] = useState(false)
  const [showInitialRightClickPopup, setShowInitialRightClickPopup] =
    useState(false)
  const [showRightClickPopup, setShowRightClickPopup] = useState(false)
  const [showRanchRightClickPopup, setShowRanchRightClickPopup] =
    useState(false)
  const [showFilterRightClickPopup, setShowFilterRightClickPopup] =
    useState(false)
  const [rightClickParcelId, setRightClickParcelId] = useState('')

  const [popupProperty, setPopupProperty] = useState({})
  const [isLoopnetProperty, setIsLoopnetProperty] = useState(false)
  const [popupLat, setPopupLat] = useState(0)
  const [popupLon, setPopupLon] = useState(0)
  const [layerPopupLat, setLayerPopupLat] = useState(0)
  const [layerPopupLon, setLayerPopupLon] = useState(0)
  const [layerPopupText, setLayerPopupText] = useState('')

  const [layerClickPopupLat, setLayerClickPopupLat] = useState(0)
  const [layerClickPopupLon, setLayerClickPopupLon] = useState(0)
  const [layerClickPopupText, setLayerClickPopupText] = useState('')

  useEffect(() => {
    if (mapRef.current) {
      var properties = {
        state_wide_parcels_2024: {
          owner: 'Owner',
          parcel_id: 'APN',
        },
        // "hydra_wd_vw" : {
        //     "agencyname": "Agency Name",
        //     "source" : "Source",
        // },
        // "hydra_gsa" : {
        //     "gsa_name":"GSA Name", "basin":"Basin", "poc_name":"POC Name", "poc_phone":"POC Phone", "poc_email":"POC Email"
        // },
        // "sgma_county" : {
        //     "namelsad": "County Name"
        // },
        rated_wd_mat_vw: {
          feature: 'Region',
        },
        rated_gsa_mat_vw: {
          feature: 'Region',
        },
        sgma_sagbi: {
          compname: 'Component Name',
          taxsubgrp: 'Taxonomy Subgroup',
          sagbi: 'SAGBI',
          rat_grp: 'rating',
          restrictns: 'Restrictions',
        },
        sgma_sagbi_unmod: {
          compname: 'Component Name',
          taxsubgrp: 'Taxonomy Subgroup',
          sagbi: 'SAGBI',
          rat_grp: 'rating',
          restrictns: 'Restrictions',
        },
        // "provisional_crops_2023" : {
        //     "main_crop": "Main Crop",
        //     "multiuse": "Multiuse",
        // },
        sgma_ewrims: {
          'ewrims.points_of_diversion.diversion_site_name': 'Site Name',
          'gis2ewrims.mv_gis_pod_attributes.appl_pod': 'Appl Pod',
          'gis2ewrims.mv_gis_pod_attributes.direct_div_amount':
            'Direct Div Amount',
          'gis2ewrims.mv_gis_pod_attributes.diversion_storage_amount':
            'Storage Amount',
          'gis2ewrims.mv_gis_pod_attributes.diversion_ac_ft': 'Acreage',
          'gis2ewrims.mv_gis_pod_attributes.pod_status': 'Status',
          'gis2ewrims.mv_gis_pod_attributes.storage_type': 'Storage Type',
          'gis2ewrims.mv_gis_pod_attributes.pod_unit': 'Unit',
        },
        all_ranches: {
          ranch_name: 'Ranch Name',
          ranch_acreage: 'Ranch Acreage',
          ranch_hydra_score: 'Ranch Hydra Score',
          ss: 'Soil Score',
        },
      }
      layerList.forEach((layer) => {
        // Handling mousemove
        // mapRef.current.on('mousemove', layer[1].id, function (e) {
        //     if(enableClick && properties.hasOwnProperty(layer[1]["source-layer"])){
        //         let props_properties = '';
        //         for (const [k, v] of Object.entries(properties[layer[1]["source-layer"]])) {
        //             props_properties += `<div key="${v}" style="font-size:16px">${v} : <strong>` + undefinedToEmpty(e.features[0].properties[k]) + `</strong><br></div>`;
        //         }
        //         const coordinates = e.lngLat;
        //         setLayerPopupLat(coordinates.lat);
        //         setLayerPopupLon(coordinates.lng);
        //         setLayerPopupText(props_properties);
        //         setShowPopup(true);
        //     }
        // });

        let enableClick = false
        mapRef.current.on('touchmove', layer[1].id, function (e) {
          enableClick = true
        })
        mapRef.current.on('touchend', layer[1].id, function (e) {
          enableClick = !enableClick

          if (enableClick) {
            let props_properties = ''
            if (!properties.hasOwnProperty(layer[1]['source-layer'])) return
            for (const [k, v] of Object.entries(
              properties[layer[1]['source-layer']]
            )) {
              props_properties +=
                `<div key="${v}" style="font-size:16px">${v} : <strong>` +
                undefinedToEmpty(e.features[0].properties[k]) +
                `</strong><br></div>`
            }
            const coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })

        mapRef.current.on('touchend', 'All Ranches', function (e) {
          enableClick = !enableClick

          if (enableClick) {
            var props_properties = ''
            for (const [k, v] of Object.entries(properties['all_ranches'])) {
              props_properties +=
                `
                                <div key="${v}" style="font-size:16px">${v} : <strong>` +
                undefinedToEmpty(e.features[0].properties[k]) +
                `</strong><br></div>
                                `
            }
            var coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })

        mapRef.current.on('click', layer[1].id, function (e) {
          enableClick = !enableClick

          if (enableClick) {
            let props_properties = ''
            if (!properties.hasOwnProperty(layer[1]['source-layer'])) return
            for (const [k, v] of Object.entries(
              properties[layer[1]['source-layer']]
            )) {
              props_properties +=
                `<div key="${v}" style="font-size:16px">${v} : <strong>` +
                undefinedToEmpty(e.features[0].properties[k]) +
                `</strong><br></div>`
            }
            const coordinates = e.lngLat
            setLayerClickPopupLat(coordinates.lat)
            setLayerClickPopupLon(coordinates.lng)
            setLayerClickPopupText(props_properties)
            setShowClickPopup(true)
          } else {
            setShowClickPopup(false)
          }
        })
        // Optionally handle mouseleave to hide the popup when mouse leaves the layer
        mapRef.current.on('mouseleave', layer[1].id, function (e) {
          setShowPopup(false)
          // setShowClickPopup(false);
        })
      })
      mapRef.current.on('mousemove', 'All Ranches', function (e) {
        var props_properties = ''
        for (const [k, v] of Object.entries(properties['all_ranches'])) {
          props_properties +=
            `
                        <div key="${v}" style="font-size:16px">${v} : <strong>` +
            undefinedToEmpty(e.features[0].properties[k]) +
            `</strong><br></div>
                        `
        }
        var coordinates = e.lngLat
        setLayerPopupLat(coordinates.lat)
        setLayerPopupLon(coordinates.lng)
        setLayerPopupText(props_properties)
        // setShowParcelPopup(false)
        setShowPopup(true)
      })
      mapRef.current.on('click', 'All Ranches', function (e) {
        setShowPopup(false)
        setShowClickPopup(false)
      })
      mapRef.current.on('mouseleave', 'All Ranches', function (e) {
        setShowPopup(false)
        setShowClickPopup(false)
      })
    }
  }, [layerList])

  const [visibility, setVisibility] = useState({
    rated_wd_mat_vw: false,
    rated_gsa_mat_vw: false,
    sgma_county: false,
    hydra_gsa: false,
    hydra_wd_vw: false,
    state_wide_parcels_2024: false,
    sgma_sagbi: false,
    sgma_sagbi_unmod: false,
    provisional_crops_2023: false,
    sgma_ewrims: false,
    all_ranches: false,
    queried_parcels: false,
  })

  const [aoiVisibility, setAoiVisibility] = useState({
    apn: false,
    sagbi: false,
    mls: false,
  })

  const [baseMapVisibility, setBaseMapVisibility] = useState({
    Aerial: true,
    Dark: false,
    Light: false,
    Topo: false,
    Streets: false,
  })

  const [selectedCounty, setSelectedCounty] = useState(null)
  const [selectedApn, setSelectedApn] = useState(null)

  const onAoiVisibilityChange = (name, value) => {
    setAoiVisibility({ ...aoiVisibility, [name]: value })
  }

  const onVisibilityChange = (name, value) => {
    // if(name === "state_wide_parcels_2024" || name === "sgma_sagbi" || name === "sgma_sagbi_unmod" || name === "provisional_crops_2023") {
    //     if (currentZoomLevel < 13) {
    //         toast.warn("This layer is not available at the current zoom level. Please zoom in to enable it.");
    //         return
    //     }
    // }
    setVisibility({
      ...visibility,
      [name]: value,
    })
    activeLayerId = name
    setShowClickPopup(false)
  }

  // useEffect(() => {
  //     if (mapRef.current) {
  //         if (currentZoomLevel < 13) {
  //             if(visibility["state_wide_parcels_2024"] || visibility["sgma_sagbi"] || visibility["sgma_sagbi_unmod"] || visibility["provisional_crops_2023"] ) {
  //                 toast.warn("Some layers are not available when you zoom out to certain levels.")
  //             }
  //             setVisibility({
  //                 ...visibility,
  //                 ["state_wide_parcels_2024"]: false,
  //                 ["sgma_sagbi"]: false,
  //                 ["sgma_sagbi_unmod"]: false,
  //                 ["provisional_crops_2023"]: false
  //             });
  //         }
  //     }
  // }, [currentZoomLevel]);

  const onBaseMapVisibilityChange = (name, value) => {
    if (!value) {
      toast.warn('One of the base maps must be selected.')
      return
    }

    // Create a new object with all values set to false
    const newVisibility = Object.fromEntries(
      Object.keys(baseMapVisibility).map((key) => [key, false])
    )

    // Set the specific key to true
    newVisibility[name] = value
    // Update state
    setBaseMapVisibility(newVisibility)
  }

  useEffect(() => {
    const newBaseMapSourceStyles = {
      Aerial: {
        key: 'google_aerial',
        id: 'google_aerial',
        type: 'raster',
        tiles: ['https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'],
        tileSize: 256,
      },
      Dark: {
        key: 'dark_matter',
        id: 'dark_matter',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',
        ],
      },
      Light: {
        key: 'positron',
        id: 'positron',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        ],
      },
      Topo: {
        key: 'topography',
        id: 'topography',
        type: 'raster',
        tiles: [
          'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
          'https://b.tile.opentopomap.org/{z}/{x}/{y}.png',
          'https://c.tile.opentopomap.org/{z}/{x}/{y}.png',
        ],
      },
      Streets: {
        key: 'streets',
        id: 'streets',
        type: 'raster',
        tiles: [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-b.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-c.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          'https://cartodb-basemaps-d.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
        ],
      },
    }
    const newBaseMapLayerStyles = {
      Aerial: {
        key: 'Aerial',
        id: 'Aerial',
        type: 'raster',
        source: 'google_aerial',
        layout: {
          visibility: baseMapVisibility['Aerial'] ? 'visible' : 'none',
        },
      },
      Dark: {
        key: 'Dark',
        id: 'Dark',
        type: 'raster',
        source: 'dark_matter',
        layout: { visibility: baseMapVisibility['Dark'] ? 'visible' : 'none' },
      },
      Light: {
        key: 'Light',
        id: 'Light',
        type: 'raster',
        source: 'positron',
        layout: { visibility: baseMapVisibility['Light'] ? 'visible' : 'none' },
      },
      Topo: {
        key: 'Topo',
        id: 'Topo',
        type: 'raster',
        source: 'topography',
        layout: { visibility: baseMapVisibility['Topo'] ? 'visible' : 'none' },
      },
      Streets: {
        key: 'Streets',
        id: 'Streets',
        type: 'raster',
        source: 'streets',
        layout: {
          visibility: baseMapVisibility['Streets'] ? 'visible' : 'none',
        },
      },
    }
    setBaseMapSourceStyles(newBaseMapSourceStyles)
    setBaseMapLayerStyles(newBaseMapLayerStyles)
  }, [baseMapVisibility])

  const onMarkerClick = (e, ln_prop) => {
    // Set the popupInfo state to trigger the rendering of the popup
    lnProperties.map((property) => {
      if (property.id == ln_prop.id) {
        setPopupProperty(property)
      }
    })
    var coordinates = e.target._lngLat
    setIsLoopnetProperty(true)
    setPopupLat(coordinates.lat)
    setPopupLon(coordinates.lng)
    setShowParcelPopup(true)
  }

  const onCountyDropdownChange = (e) => {
    e.preventDefault(e)
    setSelectedCounty(e.target.value)
  }
  const onRanchDropdownChange = (e) => {
    const ranch = ranches.find((item) => item.ranch_name === e.value)
    setShowParcelPopup(false)
    setSelectedRanch(ranch)
  }
  const onApnInputChange = (e) => {
    setSelectedApn(e.target.value)
  }
  const fitToMapBounds = () => {
    if (!isMobile && mapRef.current && mapBounds[0].length > 0) {
      mapRef.current.fitBounds(mapBounds, { padding: 200, duration: 1000 })
    } else if (mapRef.current && mapBounds[0].length > 0) {
      mapRef.current.flyTo({
        center: [
          (mapBounds[0][0] + mapBounds[1][0]) / 2,
          (mapBounds[0][1] + mapBounds[1][1]) / 2,
        ],
        zoom: 14,
        essential: true,
      })
    }
  }

  useEffect(() => {
    fitToMapBounds()
  }, [mapBounds])

  useEffect(() => {
    if (Object.keys(selectedRanch).length)
      drawParcelsByRanchId(selectedRanch.ranch_id)
  }, [selectedRanch])

  useEffect(() => {}, [showParcelPopup])

  const CustomTrigger = ({ triggerText }) => {
    return (
      <div className="CustomTrigger flex items-center space-x-1 ">
        {triggerText}
        <FaArrowAltCircleDown
          className="CustomTriggerFa"
          style={{
            position: 'absolute',
            right: 10,
            transition: 'transform 300ms',
          }}
        />
      </div>
    )
  }

  function getTileURL(lat, lon) {
    let zoom = mapRef.current.getZoom()
    let xtile = parseInt(Math.floor(((lon + 180) / 360) * (1 << zoom)))
    let ytile = parseInt(
      Math.floor(
        ((1 -
          Math.log(Math.tan(lat.toRad()) + 1 / Math.cos(lat.toRad())) /
            Math.PI) /
          2) *
          (1 << zoom)
      )
    )
    return zoom + '/' + xtile + '/' + ytile
  }

  const refBox = useRef(null)
  const refTop = useRef(null)
  const refRight = useRef(null)
  const refBottom = useRef(null)
  const refLeft = useRef(null)

  useEffect(() => {
    if (refBox.current) {
      const resizableElement = refBox.current
      const styles = window.getComputedStyle(resizableElement)
      let height = parseInt(styles.height, 10)

      let yCord = 0

      // Top
      const onMouseMoveTopResize = (event) => {
        let eventY = event.touches ? event.touches[0]['clientY'] : event.clientY
        const dy = eventY - yCord
        let tmpHeight = height - dy
        yCord = eventY
        if (isNaN(tmpHeight)) return
        height = tmpHeight < 0 ? 0 : tmpHeight
        resizableElement.style.height = `${height}px`
      }

      const onMouseUpTopResize = (event) => {
        document.removeEventListener('mousemove', onMouseMoveTopResize)
        document.removeEventListener('touchmove', onMouseMoveTopResize)
      }

      const onMouseDownTopResize = (event) => {
        let eventY = event.hasOwnProperty('touches')
          ? event.touches[0]['clientY']
          : event.clientY
        yCord = eventY
        const styles = window.getComputedStyle(resizableElement)
        resizableElement.style.bottom = styles.bottom
        resizableElement.style.top = null
        document.addEventListener('mousemove', onMouseMoveTopResize)
        document.addEventListener('mouseup', onMouseUpTopResize)
        document.addEventListener('touchmove', onMouseMoveTopResize)
        document.addEventListener('touchend', onMouseUpTopResize)
      }

      if (refTop.current) {
        const resizerTop = refTop.current
        resizerTop.addEventListener('mousedown', onMouseDownTopResize)
        resizerTop.addEventListener('touchstart', onMouseDownTopResize)
        return () => {
          resizerTop.removeEventListener('mousedown', onMouseDownTopResize)
          resizerTop.removeEventListener('touchstart', onMouseDownTopResize)
        }
      }
    }
  }, [refBox.current, refTop.current, refLeft.current])
  const [ranchName, setRanchName] = useState('')

  function onChange(e) {
    setRanchName(e.target.value)
  }

  function createRanches(add = false) {}

  async function onSubmit(e, add = false) {
    e.preventDefault()
    if (ranchName === '') {
      toast.warn('Must type ranch name first.')
      return
    } else {
      try {
        createRanches(add)
      } catch (error) {
        toast.warn(error.message)
      }
    }
  }

  function hydraScoreColor(hydraScore) {
    if (hydraScore >= 93) return '#008000'
    else if (hydraScore >= 79) return '#8FB935'
    else if (hydraScore >= 68) return '#E6E22E'
    else if (hydraScore >= 48) return '#E09C3B'
    else if (hydraScore === 'NR') return '#808080'
    else return '#E64747'
  }
  const elementRef = useRef(null)

  const [enableStartupTutorial, setEnableStartupTutorial] = useState(true)

  const handleTutorialChange = (e) => {
    var endpoint = '/set_tutorial'
    var params = {
      tutorial: !enableStartupTutorial,
      session_key: localAuth.sessionKey,
    }
    callAPI(endpoint, params).then((res) => {
      if (res.status === 'success') {
        let temp = JSON.parse(localStorage.getItem('auth'))
        temp.tutorial = !enableStartupTutorial
        localStorage.setItem('auth', JSON.stringify(temp))
      }
    })
    setEnableStartupTutorial(!enableStartupTutorial)
  }

  const firstStep = {
    content: (
      <>
        <div className="relative pb-[30px]">
          <span>
            Welcome to Hydra Score! Let’s take 1 minute to show you
            around.
          </span>
          <br />
        </div>
        <div className="relative flex items-center text-center">
          <label
            htmlFor="masterServiceAgreement"
            className="flex items-center"
          >
            <span className="ml-auto">
              Show tutorial upon startup&nbsp;
            </span>
            <input
              type="checkbox"
              id="masterServiceAgreement"
              checked={enableStartupTutorial}
              onChange={handleTutorialChange}
            />
          </label>
        </div>
      </>
    ),
    locale: { skip: <strong aria-label="skip">SKIP</strong> },
    placement: 'center',
    target: 'body',
    disableOverlay: false,
  }


  const steps = isMobile
    ? [
        firstStep,
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Tap the map to quickly drop a pin and preview property
                  boundaries and view APN, county, owner mailing address, site
                  address, and pin coordinates.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: initialMarker
            ? '.maplibregl-marker-anchor-center'
            : '#tutorial-query-point',
          title: 'Single Parcel Selection',
          disableOverlay: true,
          hideBackButton: isTrialModal ?? false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>Share your parcel(s) using the share button.</span>
              </div>
            </>
          ),
          placement: 'top',
          target: '.initial-share',
          title: 'Share Your Parcel',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Double tap on the map, or a selected parcel, to retrieve all
                  available data on that parcel including the Hydra Score and
                  Soil Score.
                </span>
              </div>
            </>
          ),
          placement: 'bottom',
          target: '#tutorial-query-point',
          title: 'Querying Data',
          disableOverlay: true,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Use the Filter Criteria button to search within a county by
                  Owner Name, GSA, Water District, Main Crop, Acreage, Hydra
                  Score, and/or Soil Score.
                </span>
              </div>
            </>
          ),
          placement: 'bottom',
          target: '.mapboxgl-ctrl-query-button',
          title: 'Searching by Criteria',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  If you know the APN of a property, use the APN Lookup to
                  quickly locate it on the map. Have a list of APN’s you need to
                  search? You can enter multiple APN’s by separating them with a
                  comma, or upload in bulk on the Portfolio tab.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: '.search-apn-icon',
          title: 'APN Search',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Overlay detailed land and water information with data layers.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: '.toggle-layers',
          title: 'Map Layers',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  View portfolio, ranch reports and your user settings.
                </span>
                <br />
                <br />
              </div>
            </>
          ),
          placement: 'bottom',
          target: '#hamburger-menu',
          title: 'Menu',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Please reach out to{' '}
                  <a
                    style={{ color: '#0000EE' }}
                    href="mailto:support@hydrascore.com"
                  >
                    support@hydrascore.com
                  </a>{' '}
                  and someone from our team will get back to you within 1
                  business day. Thank you for choosing Hydra Score.
                </span>
              </div>
            </>
          ),
          placement: 'center',
          target: 'body',
          title: 'More Questions?',
          disableOverlay: false,
        },
      ]
    : [
      firstStep,
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Left click the map to quickly drop a pin and preview property
                  boundaries and view APN, county, owner mailing address, site
                  address, and pin coordinates.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: initialMarker
            ? '.maplibregl-marker-anchor-center'
            : '#tutorial-query-point',
          title: 'Single Parcel Selection',
          disableOverlay: true,
          hideBackButton: isTrialModal ?? false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>Share your parcel(s) using the share button.</span>
              </div>
            </>
          ),
          placement: 'top',
          target: '.initial-share',
          title: 'Share Your Parcel',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Double left click on the map, or a selected parcel, to
                  retrieve all available data on that parcel including the Hydra
                  Score and Soil Score.
                </span>
              </div>
            </>
          ),
          placement: 'bottom',
          target: '#tutorial-query-point',
          title: 'Querying Data',
          disableOverlay: true,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Parcels you have queried will appear in this list where you
                  can easily find GSA and Water District information, in
                  addition to the Hydra Score and Soil Scores, property owner,
                  and acreage. Click Add to Ranch to easily move queried parcels
                  into a new or existing ranch for later analysis.
                </span>
              </div>
            </>
          ),
          placement: 'left',
          target: '#queried-card-views',
          title: 'Queried Parcels List',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Search your ranches and quickly add them to the map with one
                  click.
                </span>
              </div>
            </>
          ),
          placement: 'left',
          target: '.Collapsible:has(#your-ranches)',
          title: 'Browse Your Ranch Portfolio',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Hold <kbd>Ctrl</kbd> while left clicking to add additional
                  parcels to your selection. <br />
                  Hold <kbd>Ctrl</kbd> while double left clicking to add
                  additional parcels to your query.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: '#tutorial-query-point',
          title: 'Selecting Multiple Parcels',
          disableOverlay: true,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Right click on a selected parcel to access shortcuts for
                  common actions including add/remove selections and adding to,
                  or creating a Ranch.
                </span>
              </div>
            </>
          ),
          placement: 'bottom',
          target: initialMarker
            ? '.maplibregl-marker-anchor-center'
            : '#tutorial-query-point',
          title: 'Right Click Menu',
          disableOverlay: true,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Use the Filter Criteria button to search within a county by
                  Owner Name, GSA, Water District, Main Crop, Acreage, Hydra
                  Score, and/or Soil Score.
                </span>
              </div>
            </>
          ),
          placement: 'bottom',
          target: '.mapboxgl-ctrl-query-button',
          title: 'Searching by Criteria',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative flex flex-col items-center justify-center h-full">
                <span>
                  Use the Query by Area tool to quickly draw a box over an area
                  to select all parcels that touch that area.
                </span>
                <br />
                <img
                  src="/img/area-search.webp"
                  alt="Area Search"
                  className="object-contain"
                />
              </div>
            </>
          ),
          placement: 'right',
          target: '.aoi-icon',
          title: 'Querying by Area',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  If you know the APN of a property, use the APN Lookup to
                  quickly locate it on the map. Have a list of APN’s you need to
                  search? You can enter multiple APN’s by separating them with a
                  comma, or upload in bulk on the Portfolio tab.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: '.search-apn-icon',
          title: 'APN Search',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Overlay detailed land and water information with data layers.
                </span>
              </div>
            </>
          ),
          placement: 'right',
          target: '.toggle-layers',
          title: 'Map Layers',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  View ranch summaries, generate ranch reports, and bulk upload
                  files to quickly create multiple ranches at once from your
                  existing data.
                </span>
                <br />
                <br />
              </div>
            </>
          ),
          placement: 'bottom',
          target: '.header-portfolio',
          title: 'Portfolio',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  View and download historical ranch reports and see how scores
                  change over time.
                </span>
                <br />
                <br />
              </div>
            </>
          ),
          placement: 'bottom',
          target: '.header-reports',
          title: 'Ranch Reports',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Access your user settings here including password changes and
                  subscription management.
                </span>
                <br />
                <br />
              </div>
            </>
          ),
          placement: 'bottom',
          target: '.header-profile',
          title: 'Profile',
          disableOverlay: false,
        },
        {
          content: (
            <>
              <div className="relative">
                <span>
                  Please reach out to{' '}
                  <a
                    style={{ color: '#0000EE' }}
                    href="mailto:support@hydrascore.com"
                  >
                    support@hydrascore.com
                  </a>{' '}
                  and someone from our team will get back to you within 1
                  business day. Thank you for choosing Hydra Score.
                </span>
              </div>
            </>
          ),
          placement: 'center',
          target: 'body',
          title: 'More Questions?',
          disableOverlay: false,
        },
      ]

  const [currentStep, setCurrentStep] = useState()

  const handleJoyrideCallback = (data) => {
    const { action, index, lifecycle, status, type, origin } = data
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED]

    if(isTrialModal && index === 1 && type === EVENTS.TOUR_START && action === ACTIONS.START) {
      setCurrentStep(0)
    }
    else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        const _index = index + (action === ACTIONS.PREV ? -1 : 1)
        setCurrentStep(_index)
    }
    if (isMobile) {
      if (action === 'next' && lifecycle === 'complete' && index === 5) {
        const getBoundingBox = (coordinates) => {
          const minLat = Math.min(...coordinates.map((coord) => coord[0]))
          const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
          const minLon = Math.min(...coordinates.map((coord) => coord[1]))
          const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

          return [
            [minLon, minLat],
            [maxLon, maxLat],
          ]
        }
        if (tutorialInitialGeojson) {
          var bbox = tutorialInitialGeojson.bbox
          setMapBounds(
            getBoundingBox([
              [bbox[1], bbox[0]],
              [bbox[3], bbox[2]],
            ])
          )
        }
      }

      if (action === 'next' && lifecycle === 'complete' && index === 4) {
        setShowParcelPopup(false)
        setIsSearchOn((prevState) => ({
          ...prevState,
          ['apn']: true,
        }))
      }
      if (action === 'next' && lifecycle === 'complete' && index === 5) {
        setShowParcelPopup(false)
        setIsSearchOn((prevState) => ({
          ...prevState,
          ['apn']: false,
        }))
        toggleLayers()
      }
    } else {
      if (action === 'next' && lifecycle === 'complete' && index === 5) {
        const getBoundingBox = (coordinates) => {
          const minLat = Math.min(...coordinates.map((coord) => coord[0]))
          const maxLat = Math.max(...coordinates.map((coord) => coord[0]))
          const minLon = Math.min(...coordinates.map((coord) => coord[1]))
          const maxLon = Math.max(...coordinates.map((coord) => coord[1]))

          return [
            [minLon, minLat],
            [maxLon, maxLat],
          ]
        }
        if (tutorialInitialGeojson) {
          var bbox = tutorialInitialGeojson.bbox
          setMapBounds(
            getBoundingBox([
              [bbox[1], bbox[0]],
              [bbox[3], bbox[2]],
            ])
          )
        }
      }

      if (action === 'next' && lifecycle === 'complete' && index === 6) {
        if (popupRef.current) {
          // Get marker's lngLat
          const markerLngLat = popupRef.current.getLngLat()

          // Call defaultClickEvent with mocked right-click data
          defaultClickEvent({
            originalEvent: { ctrlKey: false },
            lngLat: markerLngLat,
            type: 'contextmenu', // Simulating right-click event
          })
        }
      }

      if (action === 'next' && lifecycle === 'complete' && index === 7) {
        setShowInitialRightClickPopup(false)
        setShowRightClickPopup(false)
        setShowRanchRightClickPopup(false)
        openModal()
      }
      if (action === 'next' && lifecycle === 'complete' && index === 8) {
        closeModal()
      }
      if (action === 'next' && lifecycle === 'complete' && index === 9) {
        setShowParcelPopup(false)
        setIsSearchOn((prevState) => ({
          ...prevState,
          ['apn']: true,
        }))
      }
      if (action === 'next' && lifecycle === 'complete' && index === 10) {
        setShowParcelPopup(false)
        setIsSearchOn((prevState) => ({
          ...prevState,
          ['apn']: false,
        }))
        toggleLayers()
      }
      if (origin === 'overlay' && index !== 15) {
        return
      }
    }
    if (
      finishedStatuses.includes(status) ||
      (action === 'close' && origin === 'button_close')
    ) {
      setJoyrideRun(false)
      freshRestart()
      navigate(
        '/' +
          (searchParams.get('locations')
            ? '?locations=' + searchParams.get('locations')
            : '')
      )
    }
  }
  return (
    <>
      {!browserName.toLowerCase().includes('chrome') &&
        !browserName.toLowerCase().includes('safari') &&
        !browserName.toLowerCase().includes('webkit') && <BrowserCheck />}
      {loading && <Spinner />}

      <div
        className={`h-full fixed ${
          window.innerWidth >= 690 && !isMobile ? 'flex' : ''
        }`}
      >
        {showModal &&
          (isMobile ? (
            <MobileParcelDetail
              showModal={showModal}
              logout={logout}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              localAuth={localAuth}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              drawParcelsByRanchId={drawParcelsByRanchId}
              onParcelDelete={onParcelDeleteFromDetail}
              onRanchDropdownChange={onRanchDropdownChange}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ) : (
            <ParcelDetail
              showModal={showModal}
              logout={logout}
              handleClose={handleClose}
              handleSuccess={handleSuccess}
              property={selectedProperty}
              localAuth={localAuth}
              selectedRanch={selectedRanch}
              setSelectedRanch={setSelectedRanch}
              drawParcelsByRanchId={drawParcelsByRanchId}
              onParcelDelete={onParcelDeleteFromDetail}
              onRanchDropdownChange={onRanchDropdownChange}
              ranches={ranches}
              setRanches={setRanches}
              onRanchParcelDelete={() =>
                onRanchParcelDelete(
                  selectedProperty.id,
                  selectedProperty.feature.properties.ranch_id,
                  selectedProperty.feature.properties.parcel_ref_id
                )
              }
            />
          ))}
        {showRanchSelectModal && (
          <RanchSelectModal
            selectedRanch={selectedRanch}
            onChange={onChange}
            ranchName={ranchName}
            onSubmit={(e) => onSubmit(e, true)}
            setSelectedParcelIds={setSelectedParcelIds}
            showRanchSelectModal={showRanchSelectModal}
            setShowRanchSelectModal={setShowRanchSelectModal}
            onRanchDropdownChange={onRanchDropdownChange}
            ranches={ranches}
            setRanches={setRanches}
            addParcelToRanch={addParcelToRanch}
            addInitialParcelToRanch={addInitialParcelToRanch}
            initialRanch={initialRanch}
            setInitialRanch={setInitialRanch}
          />
        )}
        {isSearchOn['apn'] && (
          <ApnSearchModal
            setIsSearchOn={setIsSearchOn}
            isSearchOn={isSearchOn}
            onCountyDropdownChange={onCountyDropdownChange}
            selectedCounty={selectedCounty}
            setSelectedCounty={setSelectedCounty}
            onApnInputChange={() => {}}
            selectedApn={selectedApn}
            queryApn={() => {}}
          />
        )}
        {popupContent && (
          <InfoPopup
            content={popupContent}
            onClose={() => setPopupContent(null)}
          />
        )}
        {
          <div
            id="layerBox"
            className={`absolute ${
              window.innerWidth < 690 ? 'top-[60px]' : 'top-[45px]'
            } w-[275px] z-[10] left-[-275px] ${
              isLayerOn ? 'move-right' : 'no-move'
            }`}
          >
            <LayerControlGroup
              baseMapVisibility={baseMapVisibility}
              visibility={visibility}
              onBaseMapVisibilityChange={onBaseMapVisibilityChange}
              onVisibilityChange={onVisibilityChange}
              layers={{
                'Rated Regions - Water Districts': 'rated_wd_mat_vw',
                'Rated Regions - GSAs': 'rated_gsa_mat_vw',
                County: 'sgma_county',
                GSA: 'hydra_gsa',
                'Water Districts': 'hydra_wd_vw',
                'Statewide Parcels': 'state_wide_parcels_2024',
                'SAGBI - Modified': 'sgma_sagbi',
                'SAGBI - Unmodified': 'sgma_sagbi_unmod',
                'Statewide Crops': 'provisional_crops_2023',
                'Water Rights (eWRIMS)': 'sgma_ewrims',
                'All Ranches': 'all_ranches',
                'Queried Parcel(s)': 'queried_parcels',
                'Filtered Parcel(s)': 'filtered_parcels',
              }}
              isDemoUser={isDemoUser}
              isTutorialPage={true}
              hasQueriedParcels={parcels.map((parcel) => parcel.id).length}
              hasFilteredParcels={Object.keys(filterGeoJson).length > 0}
              setPopupContent={setPopupContent}
            />
          </div>
        }
        <div
          id="tutorial-query-point"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        ></div>
        <MapProvider>
          <Map
            ref={mapRef}
            onLoad={onMapLoad}
            initialViewState={{
              longitude: SampleGeoJson.feature.properties.longitude,
              latitude: SampleGeoJson.feature.properties.latitude,
              zoom: 14,
            }}
            style={mapWidthStyle}
          >
            <Joyride
              callback={handleJoyrideCallback}
              hideCloseButton={false}
              continuous
              run={joyrideRun}
              scrollToFirstStep
              showProgress
              showSkipButton
              stepIndex={currentStep}
              disableOverlay={steps[currentStep]?.disableOverlay}
              steps={isTrialModal ? steps.slice(1) : steps}
              styles={{
                options: {
                  beaconSize: 50,
                  primaryColor: '#00ac9c',
                  zIndex: 10000, // Ensure this is high enough to cover the map
                },
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.6)', // Adjust overlay color and opacity if needed
                  zIndex: 10001, // Match the zIndex with options or make it higher to cover interactions
                  height: '100vh',
                  pointerEvents: 'none',
                },
                spotlight: {
                  zIndex: 10002, // This makes sure the spotlight is above the overlay
                },
              }}
            />
            {layerList.length > 0 &&
              layerList.map((layer) => {
                if (visibility[layer[0].id]) {
                  return (
                    <Source {...layer[0]}>
                      <Layer {...layer[1]} />
                      {layer.length > 2 && <Layer {...layer[2]} />}
                      {mapLoaded &&
                        layer.length > 3 &&
                        mapRef.current.getGlyphs() ===
                          'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' && (
                          <Layer {...layer[3]} />
                        )}
                    </Source>
                  )
                }
              })}
            {visibility['all_ranches'] &&
              mapRef.current &&
              Object.keys(ranchParcelsSource).length > 0 &&
              Object.keys(ranchParcelsLayer).length > 0 &&
              Object.keys(ranchParcelsOutlineLayer).length > 0 && (
                <Source {...ranchParcelsSource}>
                  <Layer {...ranchParcelsLayer} />
                  <Layer {...ranchParcelsOutlineLayer} />
                </Source>
              )}
            {Object.keys(baseMapSourceStyles).length > 0 &&
              Object.keys(baseMapLayerStyles).length > 0 &&
              Object.keys(baseMapSourceStyles).map((baseMap) => (
                <Source {...baseMapSourceStyles[baseMap]}>
                  <Layer {...baseMapLayerStyles[baseMap]} />
                </Source>
              ))}
            {showPopup && (
              <Popup
                closeButton={false}
                longitude={layerPopupLon}
                latitude={layerPopupLat}
              >
                <div dangerouslySetInnerHTML={{ __html: layerPopupText }} />
              </Popup>
            )}
            {showClickPopup && (
              <Popup
                closeButton={true}
                longitude={layerClickPopupLon}
                latitude={layerClickPopupLat}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: layerClickPopupText }}
                />
              </Popup>
            )}
            {/* {
                            joyrideRun && <Source id="property-source" type="geojson" data={SampleGeoJson.feature}>
                                <Layer {...{
                                            source: "property-source",
                                            id: "property-layer",
                                            type: "fill",
                                            layout: {visibility: "visible"},
                                            paint: {
                                                'fill-color': "#FFA500",
                                                'fill-opacity': 0.2,
                                                'fill-outline-color': "#FFA500",
                                            }
                                        }}/>
                                    <Layer {...{
                                                source: "property-source",
                                                id: "property-layer-outline",
                                                type: "line",
                                                layout: {
                                                    'visibility': 'visible',
                                                    'line-join': 'round',
                                                    'line-cap': 'round'
                                                },
                                                paint: {
                                                    'line-color': "#FFA500",
                                                    'line-width': 4,
                                                }
                                            }}/>
                            </Source>
                        } */}
            {visibility['filtered_parcels'] &&
              Object.keys(filterGeoJson).length > 0 && (
                <Source
                  key={`filter-source`}
                  id={`filter-source`}
                  type="geojson"
                  data={filterGeoJson}
                >
                  <Layer
                    {...{
                      source: `filter-source`,
                      id: `filter-layer`,
                      type: 'fill',
                      layout: { visibility: 'visible' },
                      paint: {
                        'fill-color': '#87ceeb',
                        'fill-opacity': 0.2,
                        'fill-outline-color': '#87ceeb',
                      },
                    }}
                  />
                  <Layer
                    {...{
                      source: `filter-source`,
                      id: `filter-layer-outline`,
                      type: 'line',
                      layout: {
                        visibility: 'visible',
                        'line-join': 'round',
                        'line-cap': 'round',
                      },
                      paint: {
                        'line-color': '#87ceeb',
                        'line-width': 4,
                      },
                    }}
                  />
                  <Layer
                    {...{
                      id: 'filter-layer-label',
                      type: 'symbol',
                      source: 'filter-source',
                      layout: {
                        visibility: 'visible',
                        'icon-image': '',
                        'text-field': [
                          'format',
                          ['get', 'parcel_id'],
                          {
                            'font-scale': 1,
                          },
                          '\n',
                        ],
                        'text-font': ['Roboto Condensed Bold'],
                        'text-offset': [0, 0],
                        'text-letter-spacing': 0,
                        'text-anchor': 'top',
                        'text-size': 14,
                      },
                      paint: {
                        'text-color': '#2c2c2c',
                        'text-halo-color': '#ffffff',
                        'text-halo-width': 2,
                      },
                    }}
                  />
                </Source>
              )}
            {showInitialRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowInitialRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <strong>Parcel ID: {rightClickParcelId}</strong>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      // onClick={()=>queryApn('','','','','',JSON.stringify(clickedGeojson.features), true)}
                    >
                      Query this parcel
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        // onClick={()=>queryApn('','','','','',JSON.stringify(initialApnSource.data.features), true)}
                      >
                        Query all parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        // setInitialRanch(1)
                        // setShowRanchSelectModal(true)
                      }}
                    >
                      Add this parcel to ranch
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          // setInitialRanch(2)
                          // setShowRanchSelectModal(true)
                        }}
                      >
                        Add all{' '}
                        <strong style={{ color: 'green' }}>selected</strong>{' '}
                        parcels to ranch
                      </li>
                    ) : (
                      <></>
                    )}
                    {Object.keys(apnSource).length > 0 &&
                    apnSource.data.features.length > 0 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          // setInitialRanch(0)
                          // queryApn('','','','','',JSON.stringify(initialApnSource.data.features), true).then((res) => {
                          //     onEditAll(res)
                          // })
                        }}
                      >
                        Add all{' '}
                        <strong style={{ color: 'green' }}>selected</strong> and{' '}
                        <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                        parcels to ranch
                      </li>
                    ) : (
                      <></>
                    )}
                    <li className="popup-list-item" onClick={() => {}}>
                      Share this parcel
                    </li>
                    {initialApnSource.data.features.length > 1 ? (
                      <li className="popup-list-item" onClick={() => {}}>
                        Share all{' '}
                        <strong style={{ color: 'green' }}>selected</strong>{' '}
                        parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      // onClick={()=>{removeInitialParcels([clickedGeojson.features[0].properties.parcel_id]) }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <strong>Parcel ID: {rightClickParcelId}</strong>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        // apnSource.data.features.forEach(feature => {
                        //     if (feature.properties.parcel_id == rightClickParcelId) {
                        //         setShowRightClickPopup(false)
                        //         onEdit(feature.id);
                        //     }
                        // });
                      }}
                    >
                      Add this parcel to ranch
                    </li>
                    {apnSource.data.features.length > 1 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          // setShowRightClickPopup(false)
                          // onEditAll()
                        }}
                      >
                        Add all{' '}
                        <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                        parcels to ranch
                      </li>
                    ) : (
                      <></>
                    )}
                    {Object.keys(initialApnSource).length > 0 &&
                    initialApnSource.data.features.length > 0 ? (
                      <li
                        className="popup-list-item"
                        onClick={() => {
                          // setInitialRanch(0)
                          // queryApn('','','','','',JSON.stringify(initialApnSource.data.features), true).then((res) => {
                          //     setShowRightClickPopup(false)
                          //     onEditAll(res)
                          // })
                        }}
                      >
                        Add all{' '}
                        <strong style={{ color: 'green' }}>selected</strong> and{' '}
                        <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                        parcels to ranch
                      </li>
                    ) : (
                      <></>
                    )}
                    <li className="popup-list-item" onClick={() => {}}>
                      Share this parcel
                    </li>
                    {apnSource.data.features.length > 1 ? (
                      <li className="popup-list-item" onClick={() => {}}>
                        Share all{' '}
                        <strong style={{ color: '#FFA500' }}>queried</strong>{' '}
                        parcels
                      </li>
                    ) : (
                      <></>
                    )}
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        // apnSource.data.features.forEach(feature => {
                        //     if (feature.properties.parcel_id == rightClickParcelId) {
                        //         setShowRightClickPopup(false)
                        //         onParcelDelete(feature.id)
                        //     }
                        // });
                      }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showFilterRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowFilterRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <strong>Parcel ID: {rightClickParcelId}</strong>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        // const updatedGeoJson = {
                        //     ...filterGeoJson, // Keep all other properties of the GeoJSON
                        //     features: filterGeoJson.features.filter(feature => feature.properties.parcel_id !== rightClickParcelId)
                        // };
                        // setShowFilterRightClickPopup(false)
                        // setFilterGeoJson(updatedGeoJson)
                      }}
                    >
                      Remove this parcel
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {showRanchRightClickPopup && (
              <Popup
                onClose={() => {
                  setShowRanchRightClickPopup(false)
                }}
                closeButton={true}
                longitude={popupLon}
                latitude={popupLat}
              >
                <div>
                  <strong>Parcel ID: {rightClickParcelId}</strong>
                  <ul className="popup-list">
                    <li
                      className="popup-list-item"
                      onClick={() => {
                        // ranchApnSource.data.features.forEach(feature => {
                        //     if (feature.properties.parcel_id == rightClickParcelId) {
                        //         setShowRanchRightClickPopup(false)
                        //         onRanchParcelDelete(feature.id, feature.properties.ranch_id, feature.properties.parcel_ref_id)
                        //     }
                        // });
                      }}
                    >
                      Remove this parcel from ranch
                    </li>
                  </ul>
                </div>
              </Popup>
            )}
            {mapLoaded &&
            mapRef.current &&
            mapRef.current?.getGlyphs() ===
              'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' &&
            Object.keys(apnSource).length > 0 &&
            Object.keys(apnLayer).length > 0 &&
            Object.keys(apnOutlineLayer).length > 0 &&
            Object.keys(apnLabelLayer).length > 0
              ? visibility['queried_parcels'] && (
                  <Source {...apnSource}>
                    <Layer {...apnLayer} />
                    <Layer {...apnOutlineLayer} />
                    <Layer {...apnLabelLayer} />
                  </Source>
                )
              : mapRef.current &&
                Object.keys(apnSource).length > 0 &&
                Object.keys(apnLayer).length > 0 &&
                Object.keys(apnOutlineLayer).length > 0 &&
                Object.keys(apnLabelLayer).length > 0 &&
                visibility['queried_parcels'] && (
                  <Source {...apnSource}>
                    <Layer {...apnLayer} />
                    <Layer {...apnOutlineLayer} />
                  </Source>
                )}
            {mapLoaded &&
              mapRef.current &&
              Object.keys(initialApnSource).length > 0 &&
              Object.keys(initialApnLayer).length > 0 &&
              Object.keys(initialApnOutlineLayer).length > 0 && (
                <Source {...initialApnSource}>
                  <Layer {...initialApnLayer} />
                  <Layer {...initialApnOutlineLayer} />
                </Source>
              )}
            {mapLoaded &&
            mapRef.current &&
            mapRef.current?.getGlyphs() ===
              'https://glyphs.hydrascore.com/assets/fonts/{fontstack}/{range}.pbf' &&
            Object.keys(ranchApnSource).length > 0 &&
            Object.keys(ranchApnLayer).length > 0 &&
            Object.keys(ranchApnOutlineLayer).length > 0 &&
            Object.keys(ranchApnLabelLayer).length > 0 ? (
              <Source {...ranchApnSource}>
                <Layer {...ranchApnLayer} />
                <Layer {...ranchApnOutlineLayer} />
                <Layer {...ranchApnLabelLayer} />
              </Source>
            ) : (
              mapRef.current &&
              Object.keys(ranchApnSource).length > 0 &&
              Object.keys(ranchApnLayer).length > 0 &&
              Object.keys(ranchApnOutlineLayer).length > 0 &&
              Object.keys(ranchApnLabelLayer).length > 0 && (
                <Source {...ranchApnSource}>
                  <Layer {...ranchApnLayer} />
                  <Layer {...ranchApnOutlineLayer} />
                </Source>
              )
            )}
            {initialMarker && (
              <Marker
                id="initialMarker"
                key={`initialMarker`}
                longitude={initialMarkerLon}
                latitude={initialMarkerLat}
                color={'green'}
                onClick={(e) => {
                  e.originalEvent.stopPropagation()
                  defaultClickEvent({
                    lngLat: e.target._lngLat,
                    type: 'contextmenu',
                  })
                }}
                ref={popupRef}
              />
            )}
          </Map>
        </MapProvider>
        <QueryFilterModal
          isOpen={isQueryFilterModalOpen}
          onClose={closeModal}
          setFilterGeoJson={setFilterGeoJson}
          setMapBounds={setMapBounds}
          setVisibility={setVisibility}
          isTutorial={true}
        />

        {mapLoaded &&
          mapRef.current &&
          initialParcels.length > 0 &&
          Object.keys(initialApnSource).length > 0 &&
          Object.keys(initialApnLayer).length > 0 &&
          Object.keys(initialApnOutlineLayer).length > 0 && (
            <InitialParcelCardView
              parcelData={initialParcels}
              handleInitialParcelSelection={handleInitialParcelSelection}
              queryApn={() => {}}
              initialApnSource={initialApnSource}
              clickedGeojson={clickedGeojson}
              removeInitialParcels={removeInitialParcels}
              setClickedGeojson={setClickedGeojson}
              setCurrentIndex={setCurrentIndex}
              currentIndex={currentIndex}
              setShowInitialRightClickPopup={setShowInitialRightClickPopup}
              setInitialMarker={setInitialMarker}
              initialParcelLayersData={initialParcelLayersData}
            />
          )}

        {!isMobile &&
          (window.innerWidth < 690 ? (
            <div
              ref={refBox}
              className={`bg-white resizable-box shadow-md hover:shadow-xl transition-shadow duration-150 item-center overflow-y-auto z-10 ${
                window.innerWidth >= 690 ? 'sticky right-0' : 'sticky bottom-0'
              }`}
              style={propertyWidthStyle}
            >
              <div ref={refTop} className="resizer rt" onClick={() => {}}>
                <svg className="Icon" viewBox="0 0 24 24">
                  <path
                    fill="black"
                    d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                  />
                </svg>
              </div>

              <ul
                className={`grid ${
                  window.innerWidth >= 690 ? '' : 'mt-[10px]'
                }`}
              >
                {!isLoggedIn ? (
                  <div className="mt-10 text-center w-full content-center">
                    <div className="relative">
                      <button
                        // onClick={()=> {navigate('/profile')}}
                        className="px-7 py-3 bg-blue-600 text-white font-medium text-sm uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg w-[70%] text-center transition duration-150 ease-in-out "
                      >
                        Sign In
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <Collapsible trigger="Legend">
                      <div>Hydra Score</div>
                      <img
                        src={legendImage}
                        width={200}
                        title="Areas with an 'Excellent' rating may have abundant ground and surface water, with potentially no restrictions planned, or such minimal restrictions that farmers can easily meet current crop demands.&#013;&#013;Areas receiving a 'Good' rating may have a reliable supply of ground and/or surface water, with minor restrictions that do not significantly impede agricultural productivity or crop water requirements.&#013;&#013;An 'Average' rating is given to areas where ground and/or surface water supplies could be adequate, but some restrictions may be necessary, potentially affecting certain high-water-demand crops.&#013;&#013;‘Marginal' areas may struggle with their ground and/or surface water resources, facing restrictions that can make it difficult for farmers to achieve optimal crop yields without careful water management.&#013;&#013;Areas with a 'Poor' rating could face a critical shortage of ground and surface water, resulting in severe restrictions that severely limit farming operations and crop production.&#013;&#013;Areas 'Not yet rated' have not been evaluated, and thus there is no information on whether their ground and surface water supplies can sustain current and planned agricultural uses."
                      />
                    </Collapsible>
                    <Collapsible
                      trigger={
                        <div
                          id="your-ranches"
                          className="CustomTrigger relative flex items-center space-x-1 "
                        >
                          {'Your Ranches'}
                          <span
                            title="Remove all queried parcels from the list"
                            className={`absolute right-3 ${
                              Object.keys(selectedRanch).length === 0
                                ? 'cursor-not-allowed'
                                : 'cursor-pointer'
                            } text-sm`}
                            onClick={(event) => {
                              event.stopPropagation()
                              clearRanchSelection()
                            }}
                          >
                            Clear
                          </span>
                        </div>
                      }
                      open={true}
                    >
                      <RanchSelector
                        ranches={ranches}
                        onRanchDropdownChange={onRanchDropdownChange}
                        selectedRanch={selectedRanch}
                      />
                      {/* <div style={{height: "200px", minWidth: "400px"}}>
                                                    <Dropdown options={ranches.map(ranch => ranch.ranch_name)} onChange={onRanchDropdownChange} placeholder="Select your ranch" value={selectedRanch.ranch_name} />
                                                </div> */}
                    </Collapsible>
                    {parcels.map((parcel) => parcel.id).length !== 0 && (
                      <Collapsible
                        trigger={
                          <div className="CustomTrigger relative flex items-center space-x-1 overflow-y-auto">
                            {'Queried Parcel(s)'}
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-[65px] ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                // onEditAll()
                              }}
                            >
                              Add to Ranch
                            </span>
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-3 ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                // onParcelDeleteAll();
                              }}
                            >
                              Clear
                            </span>
                          </div>
                        }
                        open={true}
                        // trigger={"Queried Parcel(s)"}
                      >
                        <div id="queried-card-views">
                          {parcels.length ? (
                            parcels.map((parcel) => (
                              <div key={parcel.id}>
                                <ParcelCardView
                                  page={'/home'}
                                  id={parcel.id}
                                  onParcelDelete={() => {}}
                                  onRanchParcelDelete={() => {}}
                                  onEdit={() => {}}
                                  property={parcel}
                                  onPropertyClicked={() => {}}
                                  handlePropertyMouseOver={
                                    handlePropertyMouseOver
                                  }
                                  handlePropertyMouseOut={
                                    handlePropertyMouseOut
                                  }
                                  isDemoUser={isDemoUser}
                                  setLoading={setLoading}
                                  setPopupContent={setPopupContent}
                                />
                              </div>
                            ))
                          ) : (
                            <strong className="ml-5 mt-5 mr-5">
                              No Parcels queried
                            </strong>
                          )}
                        </div>
                      </Collapsible>
                    )}
                  </div>
                )}
              </ul>
            </div>
          ) : (
            <div
              className={`collapsible-menu rounded-md bg-white resizable-box shadow-md hover:shadow-xl transition-shadow duration-150 item-center overflow-y-auto z-10`}
            >
              <ul className={`grid`}>
                {
                  <div>
                    <Collapsible id="legend-collapsible" trigger="Legend">
                      <strong>Hydra Score</strong>
                      <div style={{ position: 'relative' }}>
                        <img src={legendImage} width={200} />
                        <button
                          style={{
                            height: '20px',
                            width: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            border: '1px solid #00ac9c',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            transition:
                              'box-shadow 0.3s ease, transform 0.3s ease',
                            position: 'absolute',
                            top: '8px', // Adjust to fit the top of the parent
                            right: '8px', // Adjust to fit the right corner of the parent
                          }}
                          onClick={() =>
                            setPopupContent(`An <strong style="color: #008000">Excellent</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 4 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #8fb935">Good</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 3 acre-feet (AF) per acre.\n
                                                    An <strong style="color: #e6e22e">Average</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand between 2-3 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #e09c3b">Marginal</strong> Hydra Score™ indicates that on an average annual basis, this land will be able to sustainably irrigate a crop with a water demand up to 2 acre-feet (AF) per acre.\n
                                                    A <strong style="color: #e64747">Poor</strong> Hydra Score™ indicates that on an average annual basis, this land cannot reasonably be expected to sustain a crop with a water demand greater than 1.5 acre-feet (AF) per acre.\n
                                                    Areas marked as <strong style="color: #808080">“Not Yet Rated"</strong> indicates a region outside the current scope of the platform. If you have a specific area that you would like scored, please reach out to our sales team at sales@hydrascore.com.`)
                          }
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 4px 10px rgba(0, 0, 0, 0.3)')
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 2px 5px rgba(0, 0, 0, 0.2)')
                          }
                        >
                          <FaCircleInfo color="#00ac9c" />
                        </button>
                      </div>
                      <strong>Soil Score</strong>
                      <div style={{ position: 'relative' }}>
                        <img src={legendImage} width={200} />
                        <button
                          style={{
                            height: '20px',
                            width: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            border: '1px solid #00ac9c',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            transition:
                              'box-shadow 0.3s ease, transform 0.3s ease',
                            position: 'absolute',
                            top: '8px', // Adjust to fit the top of the parent
                            right: '8px', // Adjust to fit the right corner of the parent
                          }}
                          onClick={() =>
                            setPopupContent(`The Soil Score, developed by the Hydra score team, is a comprehensive metric that integrates multiple factors, both empirical and subjective, to evaluate proximity to ideal conditions.\n
                                                    Areas with an <strong style="color: #008000">Excellent</strong> Soil Score exhibit optimal chemical/physical/hydrologic characteristics that support a wide range of field crops without any significant management issues.\n
                                                    Areas receiving a <strong style="color: #8fb935">Good</strong> Soil Score exhibit soil conditions that generally meet crop needs with minor adjustments needed, supported by favorable conditions, allowing for stable agricultural productivity.\n
                                                    An <strong style="color: #e6e22e">Average</strong> Soil Score is assigned to areas where soils adequately meet crop requirements but may exhibit some challenges such as less than ideal water percolation or retention, requiring moderate soil and water management strategies.\n
                                                    Areas rated as <strong style="color: #e09c3b">Marginal</strong> face challenges with more pronounced issues like limited deep percolation or higher salinity, impacting water quality and distribution, thus necessitating careful management to optimize crop yield and health.\n
                                                    Areas with a <strong style="color: #e64747">Poor</strong> Soil Score are significantly hindered by inadequate chemical/physical/hydrologic characteristics, which indicate potentially serious problems, severely limiting agricultural capabilities and crop diversity.\n
                                                    Areas marked as <strong style="color: #808080">“Not Yet Rated"</strong> have not been assessed for their chemical/physical/hydrologic characteristics, leaving uncertainties about their suitability for agriculture based on soil and water management criteria.`)
                          }
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 4px 10px rgba(0, 0, 0, 0.3)')
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              '0 2px 5px rgba(0, 0, 0, 0.2)')
                          }
                        >
                          <FaCircleInfo color="#00ac9c" />
                        </button>
                      </div>
                    </Collapsible>
                    <Collapsible
                      trigger={
                        <div
                          id="your-ranches"
                          className="CustomTrigger relative flex items-center space-x-1 "
                        >
                          {'Your Ranches'}
                          <span
                            title="Clear selected ranch"
                            className={`absolute right-3 ${
                              Object.keys(selectedRanch).length === 0
                                ? 'cursor-not-allowed'
                                : 'cursor-pointer'
                            } text-sm`}
                            onClick={(event) => {
                              event.stopPropagation()
                              clearRanchSelection()
                            }}
                          >
                            Clear
                          </span>
                        </div>
                      }
                      open={true}
                    >
                      <RanchSelector
                        ranches={ranches}
                        onRanchDropdownChange={onRanchDropdownChange}
                        selectedRanch={selectedRanch}
                      />
                      {/* <div id="ranchDropdown" style={{height: "200px", minWidth: "400px"}}>
                                                <Dropdown options={ranches.map(ranch => ranch.ranch_name)} onChange={onRanchDropdownChange} placeholder="Select your ranch" value={selectedRanch.ranch_name}/>
                                            </div> */}
                    </Collapsible>
                    {parcels.map((parcel) => parcel.id).length !== 0 && (
                      <Collapsible
                        open={true}
                        trigger={
                          <div className="CustomTrigger relative flex items-center space-x-1 ">
                            {'Queried Parcel(s)'}
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-[65px] ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                // onEditAll()
                              }}
                            >
                              Add to Ranch
                            </span>
                            <span
                              title="Remove all queried parcels from the list"
                              className={`absolute right-3 ${
                                parcels.map((parcel) => parcel.id).length === 0
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              } text-sm`}
                              onClick={(event) => {
                                event.stopPropagation()
                                // onParcelDeleteAll();
                              }}
                            >
                              Clear
                            </span>
                          </div>
                        }
                        // trigger={"Queried Parcel(s)"}
                      >
                        <div id="queried-card-views">
                          {parcels.length ? (
                            parcels.map((parcel) => (
                              <div key={parcel.id}>
                                <ParcelCardView
                                  page={'/home'}
                                  id={parcel.id}
                                  onParcelDelete={() => {}}
                                  onRanchParcelDelete={() => {}}
                                  onEdit={() => {}}
                                  property={parcel}
                                  onPropertyClicked={() => {}}
                                  handlePropertyMouseOver={
                                    handlePropertyMouseOver
                                  }
                                  handlePropertyMouseOut={
                                    handlePropertyMouseOut
                                  }
                                  isDemoUser={isDemoUser}
                                  setLoading={setLoading}
                                  setPopupContent={setPopupContent}
                                />
                              </div>
                            ))
                          ) : (
                            <strong className="ml-5 mt-5 mr-5">
                              No Parcels queried
                            </strong>
                          )}
                        </div>
                      </Collapsible>
                    )}
                  </div>
                }
              </ul>
            </div>
          ))}
      </div>
    </>
  )
}
